import React, { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import APIService from "../../Service/APIService";
import GenericForm from "../GenericForm/GenericForm";
import { UploadOutlined } from "@ant-design/icons";
import InvoiceForm from "../InvoiceForm/InvoiceForm";
import InvoiceFormNew from "../InvoiceForm/InvoiceFormNew";
import { Modal, Button, Space, Table, Switch } from "antd";
import Config from "../../Config/Config.js";
import { components } from "../tableConfig";
import { set } from "date-fns";
import { Formik } from "formik";
import { Input, Row, Col, Form, message, Upload } from "antd";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
// import moment from 'moment';
import dayjs from "dayjs";
import { LoadingOutlined } from "@ant-design/icons";
import { Badge, Spin } from "antd";
import {
  SearchOutlined,
  EditOutlined,
  CloseCircleOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import "./GenDashCss.css";
import AssignAccountToDistUser from "./AssignAccountToDistUser";
import ChangeAssignmentDistUser from "./ChangeAssignmentDistUser";
import InvoiceHomeOrderProductsEdit from "./InvoiceHomeOrderProductsEdit";
import CommonTable from "../../common/table/index.js";
import TableLink from "../../common/table/table-link/index.js";
import TableOptionsCell from "../../common/table/table-options-cell/index.js";
import { useScreen } from "../Utils/Screens.js";
import { filter } from "jszip";
import StatusIndicator from "../../common/status-indicator/index.js";
import StatusIndicatorHeader from "../../common/status-indicator/status-indicator.js";
import { colors } from "../../theme/colors.js";
import ModalView from "../../common/modal/index.js";
import TextInput from "../../common/text-input/index.js";
import RequiredIcon from "../../icons/required-icon.js";
import Text from "../../common/typography/text.js";
import CommonButton from "../../common/button/button.js";
import DropdownComponent from "../../common/dropdown-input/index.js";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
import { getApprovalRowAction } from "../Approvals/approvalQueuePolicy.js";
import { canAdminPerformUserAction } from "../UserTable/userActionAccess.js";
import { getAccountRoleLabel } from "../../Service/userService.js";
import AttachDpaModal from "../Account/AttachDpaModal";
import { canAttachDpa } from "../Account/accountManufacturerDpaAccess";

const ACCOUNT_HOME_ORDER_STATUS_TYPES = {
  Approved: "success",
  Completed: "complete",
  Shipped: "complete",
  Delivered: "success",
  Pending: "warning",
  Rejected: "failure",
  "Payment Failed": "failure",
  Voided: "voided",
};

// Orders are viewed on type-specific detail routes (see the OrdersDashboard
// "View" action), not a generic /Orders/:id route.
const getOrderDetailPath = (order) => {
  switch (order?.OrderType) {
    case "Consignment Order":
    case "CO":
      return `/ConsignmentOrder/${order.ID}`;
    case "Product Usage":
    case "PU":
      return `/ProductUsage/${order.ID}`;
    case "Direct Order":
    case "DO":
    default:
      return `/DirectOrder/${order.ID}`;
  }
};

const GenericDashboard = (props) => {
  const { user, isReady } = useAuth();
  const [attachDpaRow, setAttachDpaRow] = useState(null);
  const userData = user;
  const navigate = useNavigate();
  const {
    data,
    screen,
    totalCount,
    totalPages,
    userType,
    additionalData,
    approvalTabType = "standard",
    readOnly = false,
    // When the parent renders its own search (e.g. inside the page TitleBar),
    // it hides this component's built-in search bar and drives filtering via
    // the controlled externalSearchKeyword prop instead.
    hideInternalSearch = false,
    externalSearchKeyword = "",
    // When true, the underlying table renders skeleton rows instead of data so
    // the layout is reserved while the parent is still fetching.
    loading = false,
  } =
    props;
  React.useEffect(() => { setAttachDpaRow(null); }, [additionalData?.ID, screen]);
  const [searchResult, setSearchResult] = React.useState(data);
  const [columns, setColumns] = React.useState([]);
  const [linkChange, setLinkChange] = React.useState(false);

  const DistributorDataScreen = screen === "DistributorData";
  const DistributorAccountScreen = screen === "DistributorAccount";
  const AccountHomeInvoiceScreen = screen === "AccountHomeInvoiceTable";
  const AccountHomeRecentOrdersScreen = screen === "AccountHomeRecentOrders";
  const AccountManufacturerScreen = screen === "AccountManufacturer";
  const AccountUsersScreen = screen === "AccountUsers";
  const ManufacturerUsersScreen = screen === "ManufacturerUsers";
  const ChildAccountsScreen = screen === "ChildAccounts";
  const ApprovalsDashboardScreen = screen === "ApprovalsDashboard";
  const isPrepaidApprovalsTab =
    ApprovalsDashboardScreen && approvalTabType === "prepaid";
  const InvoiceDashboardNewScreen = screen === "InvoiceDashboardNew";
  const AccountProductLogScreen = screen === "AccountProductLog";
  const AccountConsignmentDashboardScreen =
    screen === "AccountConsignmentDashboard";
  const ManufacturerDashboardScreen = screen === "ManufacturerDashboard";
  const ASUsersDashboardScreen = screen === "ASUsersDashboard";
  const AccountUserDashboardScreen = screen === "AccountUserDashboard";
  const DistributorUserDashboardScreen = screen === "DistributorUserDashboard";
  const ManufacturerAccountDashboardScreen =
    screen === "ManufacturerAccountDashboard";
  const ManufacturerProductScreen = screen === "ManufacturerProduct";
  const canInviteUsers = canAdminPerformUserAction(userData, "user.invite");
  const canRevokeUsers = canAdminPerformUserAction(userData, "user.revoke");

  const getDashboardSchema = (type) => {
    switch (type) {
      case "AccountDashboard":
        return Config.ColumnConfigs.AccountDashboard;
      case "DistributorDashboard":
        return Config.ColumnConfigs.DistributorDashboard;
      case "ManufacturerDashboard":
        return Config.ColumnConfigs.ManufacturerDashboard;
      case "ManufacturerProduct":
        return Config.ColumnConfigs.ManufacturerProduct;
      case "AccountManufacturer":
        return Config.ColumnConfigs.AccountManufacturer;
      case "DistributorAccount":
        return Config.ColumnConfigs.DistributorAccount;
      case "DistributorUsers":
        return Config.ColumnConfigs.DistributorUsers;
      case "ProductPricing":
        return Config.ColumnConfigs.ProductPricing;
      case "ChildAccounts":
        return Config.ColumnConfigs.ChildAccounts;
      case "ApprovalsDashboard":
        return Config.ColumnConfigs.Approvals;
      case "OrdersDashboard":
        return Config.ColumnConfigs.Orders;
      case "InvoiceDashboard":
        return Config.ColumnConfigs.InvoiceDashboard;
      case "InvoiceHomeOrderDetails":
        return Config.ColumnConfigs.InvoiceHomeOrderDetails;
      case "InvoiceHomeOrderProducts":
        return Config.ColumnConfigs.InvoiceHomeOrderProducts;
      case "IVRSubmissions":
        return Config.ColumnConfigs.IVRSubmissions;
      case "ProductLog":
        return Config.ColumnConfigs.ProductLog;
      case "IVRManufacturers":
        return Config.ColumnConfigs.IVRManufacturers;
      case "AccountConsignmentDashboard":
        return Config.ColumnConfigs.AccountConsignmentDashboard;
      case "ManufacturerAccountDashboard":
        return Config.ColumnConfigs.ManufacturerAccountDashboard;
      case "AccountUsers":
        return Config.ColumnConfigs.AccountUsers;
      case "InvoiceHomePaymentsApplied":
        return Config.ColumnConfigs.InvoiceHomePaymentsApplied;
      case "AccountHomeInvoiceTable":
        return Config.ColumnConfigs.AccountHomeInvoiceTable;
      case "AccountHomeRecentOrders":
        return Config.ColumnConfigs.AccountHomeRecentOrders;
      case "DistributorHomeInvoiceTable":
        return Config.ColumnConfigs.DistributorHomeInvoiceTable;
      case "ASUsersDashboard":
        return Config.ColumnConfigs.ASUsersDashboard;
      case "AccountUserDashboard":
        return Config.ColumnConfigs.AccountUserDashboard;
      case "DistributorUserDashboard":
        return Config.ColumnConfigs.DistributorUserDashboard;
      case "AccountProductLog":
        return Config.ColumnConfigs.AccountProductLog;
      default:
        return [];
    }
  };

  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [filteredInfo, setFilteredInfo] = React.useState({});
  const [sortedInfo, setSortedInfo] = React.useState({});

  // Mirror the parent-controlled keyword into internal state so every existing
  // consumer of searchKeyword (column filters, table) keeps working unchanged.
  React.useEffect(() => {
    if (hideInternalSearch) {
      setSearchKeyword(externalSearchKeyword || "");
    }
  }, [hideInternalSearch, externalSearchKeyword]);

  const clearAll = () => {
    console.log("Clear Filters");
    setFilteredInfo({});
    setSortedInfo({});
  };

  const hasInvitableEmail = (record) => {
    if (!record || typeof record.Email !== "string") {
      return false;
    }

    return record.Email.trim().length > 0;
  };

  const generateSchema = (type) => {
    const schema = getDashboardSchema(type);
    const columns = [];

    if (type === "AccountManufacturer") {
      if (userData.Type === "Account") {
        for (const cur of schema) {
          if (cur.displayName === "Action") {
            continue;
          }
          if (
            cur.isDisplayed &&
            cur.isSearchable &&
            (cur.isFormatter === false ||
              cur.isFormatter === undefined ||
              cur.isFormatter === null) &&
            (cur.isSpecial === false ||
              cur.isSpecial === undefined ||
              cur.isSpecial === null)
          ) {
            // console.log("Inside AccountName Column");
            columns.push({
              title: cur.displayName,
              dataIndex: cur.backendName,
              key: cur.backendName,
              // filteredValue: filteredInfo.AccountName || null,
              filteredValue: [searchKeyword],
              onFilter: (value, record) => {
                if (screen === "ApprovalsDashboard") {
                  if (record.PONumber && record.AccountName) {
                    return (
                      record.PONumber.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.AccountName.toLowerCase().includes(
                        value.toLowerCase()
                      )
                    );
                  }
                } else if (screen === "InvoiceDashboard") {
                  if (
                    record.PONumber &&
                    record.AccountName &&
                    record.InvoiceNumber
                  ) {
                    return (
                      record.PONumber.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.AccountName.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.InvoiceNumber.toLowerCase().includes(
                        value.toLowerCase()
                      )
                    );
                  }
                } else if (screen === "OrdersDashboard") {
                  if (
                    record.PONumber &&
                    record.AccountName &&
                    record.OrderType &&
                    record.OrderStatus &&
                    record.ManufacturerName
                  ) {
                    return (
                      record.PONumber.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.AccountName.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.OrderType.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.OrderStatus.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.ManufacturerName.toLowerCase().includes(
                        value.toLowerCase()
                      )
                    );
                  }
                } else if (screen === "AccountProductLog") {
                  if (record.ProductCode && record.TissueID) {
                    return (
                      record.TissueID.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.Patient.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.ProductCode.toLowerCase().includes(
                        value.toLowerCase()
                      )
                    );
                  }
                } else if (screen === "DistributorDashboard") {
                  if (record.DistributorName) {
                    return record.DistributorName.toLowerCase().includes(
                      value.toLowerCase()
                    );
                  }
                } else if (screen === "IVRSubmissions") {
                  if (record.IVRASID && record.AccountName) {
                    return (
                      record.IVRASID.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.AccountName.toLowerCase().includes(
                        value.toLowerCase()
                      )
                    );
                  }
                } else if (screen === "AccountConsignmentDashboard") {
                  if (record.TissueID && record.ProductCode) {
                    return (
                      record.TissueID.toLowerCase().includes(
                        value.toLowerCase()
                      ) ||
                      record.ProductCode.toLowerCase().includes(
                        value.toLowerCase()
                      )
                    );
                  }
                }
              },
              sortIcon: ({ sortOrder }) => {
                return sortOrder !== "ascend" && sortOrder !== "descend" ? (
                  <SortAscendingOutlined />
                ) : sortOrder === "ascend" ? (
                  <SortDescendingOutlined />
                ) : sortOrder === "descend" ? (
                  <CloseCircleOutlined />
                ) : (
                  <CloseCircleOutlined />
                );
              },
              showSorterTooltip: { target: "full-header" },
              sorter: (a, b) => {
                console.log("cur: ", cur);
                if (cur.type === "date") {
                  console.log("includes date");
                  return (
                    dayjs(a[`${cur.backendName}`]).unix() -
                    dayjs(b[`${cur.backendName}`]).unix()
                  );
                } else if (
                  typeof (a[`${cur.backendName}`]
                    ? a[`${cur.backendName}`]
                    : "0" || 0) === "number"
                ) {
                  console.log("includes number");
                  return a[`${cur.backendName}`] - b[`${cur.backendName}`];
                } else if (
                  (a[`${cur.backendName}`]
                    ? a[`${cur.backendName}`]
                    : ""
                  )?.includes("$")
                ) {
                  console.log("includes dolalr");
                  console.log("backend name: ", cur.backendName);
                  console.log("strng total: ", a[`${cur.backendName}`]);
                  console.log(
                    "total: ",
                    Number(
                      a[`${cur.backendName}`].replace("$", "").replace(",", "")
                    )
                  );
                  return (
                    Number(
                      a[`${cur.backendName}`].replace("$", "").replace(",", "")
                    ) -
                    Number(
                      b[`${cur.backendName}`].replace("$", "").replace(",", "")
                    )
                  );
                } else if (typeof a[`${cur.backendName}`] === "string") {
                  return (
                    a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
                  )?.localeCompare(
                    b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
                  );
                } else {
                  console.log("invalid");
                }
              },
              sortDirections: ["ascend", "descend"],
            });
          } else if (
            cur.isDisplayed &&
            (cur.isFormatter === false ||
              cur.isFormatter === undefined ||
              cur.isFormatter === null) &&
            (cur.isSpecial === false ||
              cur.isSpecial === undefined ||
              cur.isSpecial === null)
          ) {
            columns.push({
              title: cur.displayName,
              dataIndex: cur.backendName,
              key: cur.backendName,
              sortIcon: ({ sortOrder }) => {
                return sortOrder !== "ascend" && sortOrder !== "descend" ? (
                  <SortAscendingOutlined />
                ) : sortOrder === "ascend" ? (
                  <SortDescendingOutlined />
                ) : sortOrder === "descend" ? (
                  <CloseCircleOutlined />
                ) : (
                  <CloseCircleOutlined />
                );
              },
              showSorterTooltip: { target: "full-header" },
              sorter: (a, b) => {
                if (cur.type === "date") {
                  console.log("includes date");
                  return (
                    dayjs(a[`${cur.backendName}`]).unix() -
                    dayjs(b[`${cur.backendName}`]).unix()
                  );
                } else if (
                  typeof (a[`${cur.backendName}`]
                    ? a[`${cur.backendName}`]
                    : 0) === "number"
                ) {
                  console.log("includes number");
                  return a[`${cur.backendName}`] - b[`${cur.backendName}`];
                } else if (
                  (a[`${cur.backendName}`]
                    ? a[`${cur.backendName}`]
                    : ""
                  )?.includes("$")
                ) {
                  console.log("includes dolalr");
                  return (
                    a[`${cur.backendName}`].replace("$", "").replace(",", "") -
                    b[`${cur.backendName}`].replace("$", "").replace(",", "")
                  );
                } else if (typeof a[`${cur.backendName}`] === "string") {
                  return (
                    a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
                  )?.localeCompare(
                    b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
                  );
                }
              },
              sortDirections: ["ascend", "descend"],
            });
          } else if (cur.isDisplayed && cur.isSpecial) {
            columns.push({
              title: cur.displayName,
              dataIndex: cur.backendName,
              key: cur.backendName,
            });
          } else if (cur.isDisplayed && cur.isFormatter) {
            const obj = createFormatter(cur);
            columns.push(obj);
          }
        }
        return columns;
      }
    }
    for (const cur of schema) {
      if (
        cur.isDisplayed &&
        cur.isSearchable &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null) &&
        (cur.isSpecial === false ||
          cur.isSpecial === undefined ||
          cur.isSpecial === null)
      ) {
        // console.log("Inside AccountName Column");
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          // filteredValue: filteredInfo.AccountName || null,
          filteredValue: [searchKeyword],
          onFilter: (value, record) => {
            if (screen === "AccountDashboard") {
              if (
                record.AccountName &&
                record.DistributorName &&
                record.RegionName &&
                record.SalesYTD
              ) {
                return (
                  record.AccountName.toLowerCase().includes(
                    value.toLowerCase()
                  ) ||
                  record.DistributorName.toLowerCase().includes(
                    value.toLowerCase()
                  ) ||
                  record.RegionName.toLowerCase().includes(value.toLowerCase())
                );
              } else {
                console.log("Invalid Record: ", record);
              }
              // return record;
            } else if (screen === "ApprovalsDashboard") {
              if (record.PONumber && record.AccountName) {
                return (
                  record.PONumber.toLowerCase().includes(value.toLowerCase()) ||
                  record.AccountName.toLowerCase().includes(value.toLowerCase())
                );
              }
            } else if (screen === "InvoiceDashboard") {
              if (
                record.PONumber &&
                record.AccountName &&
                record.InvoiceNumber
              ) {
                return (
                  record.PONumber.toLowerCase().includes(value.toLowerCase()) ||
                  record.AccountName.toLowerCase().includes(
                    value.toLowerCase()
                  ) ||
                  record.InvoiceNumber.toLowerCase().includes(
                    value.toLowerCase()
                  )
                );
              }
            } else if (screen === "OrdersDashboard") {
              if (
                record.PONumber &&
                record.AccountName &&
                record.OrderType &&
                record.OrderStatus &&
                record.ManufacturerName
              ) {
                return (
                  record.PONumber.toLowerCase().includes(value.toLowerCase()) ||
                  record.AccountName.toLowerCase().includes(
                    value.toLowerCase()
                  ) ||
                  record.OrderType.toLowerCase().includes(
                    value.toLowerCase()
                  ) ||
                  record.OrderStatus.toLowerCase().includes(
                    value.toLowerCase()
                  ) ||
                  record.ManufacturerName.toLowerCase().includes(
                    value.toLowerCase()
                  )
                );
              }
            } else if (screen === "AccountProductLog") {
              if (record.ProductCode && record.TissueID) {
                return (
                  record.TissueID.toLowerCase().includes(value.toLowerCase()) ||
                  record.Patient.toLowerCase().includes(value.toLowerCase()) ||
                  record.ProductCode.toLowerCase().includes(value.toLowerCase())
                );
              }
            } else if (screen === "DistributorDashboard") {
              if (record.DistributorName) {
                return record.DistributorName.toLowerCase().includes(
                  value.toLowerCase()
                );
              }
            } else if (screen === "IVRSubmissions") {
              if (record.IVRASID && record.AccountName) {
                return (
                  record.IVRASID.toLowerCase().includes(value.toLowerCase()) ||
                  record.AccountName.toLowerCase().includes(value.toLowerCase())
                );
              }
            } else if (screen === "AccountConsignmentDashboard") {
              if (record.TissueID && record.ProductCode) {
                return (
                  record.TissueID.toLowerCase().includes(value.toLowerCase()) ||
                  record.ProductCode.toLowerCase().includes(value.toLowerCase())
                );
              }
            } else if (screen === "ManufacturerDashboard") {
              if (record.ManufacturerName) {
                return record.ManufacturerName.toLowerCase().includes(
                  value.toLowerCase()
                );
              }
            }
          },
          sortIcon: ({ sortOrder }) => {
            return sortOrder !== "ascend" && sortOrder !== "descend" ? (
              <SortAscendingOutlined />
            ) : sortOrder === "ascend" ? (
              <SortDescendingOutlined />
            ) : sortOrder === "descend" ? (
              <CloseCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            );
          },
          showSorterTooltip: { target: "full-header" },
          sorter: (a, b) => {
            console.log("cur: ", cur);
            if (cur.type === "date") {
              console.log("includes date");
              return (
                dayjs(a[`${cur.backendName}`]).unix() -
                dayjs(b[`${cur.backendName}`]).unix()
              );
            } else if (
              typeof (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : "0" || 0) === "number"
            ) {
              console.log("includes number");
              return a[`${cur.backendName}`] - b[`${cur.backendName}`];
            } else if (
              (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : ""
              )?.includes("$")
            ) {
              console.log("includes dolalr");
              console.log("backend name: ", cur.backendName);
              console.log("strng total: ", a[`${cur.backendName}`]);
              console.log(
                "total: ",
                Number(
                  a[`${cur.backendName}`].replace("$", "").replace(",", "")
                )
              );
              return (
                Number(
                  a[`${cur.backendName}`].replace("$", "").replace(",", "")
                ) -
                Number(
                  b[`${cur.backendName}`].replace("$", "").replace(",", "")
                )
              );
            } else if (typeof a[`${cur.backendName}`] === "string") {
              return (
                a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
              )?.localeCompare(
                b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
              );
            } else {
              console.log("invalid");
            }
          },
          sortDirections: ["ascend", "descend"],
        });
      } else if (
        cur.isDisplayed &&
        (cur.isFormatter === false ||
          cur.isFormatter === undefined ||
          cur.isFormatter === null) &&
        (cur.isSpecial === false ||
          cur.isSpecial === undefined ||
          cur.isSpecial === null)
      ) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          sortIcon: ({ sortOrder }) => {
            return sortOrder !== "ascend" && sortOrder !== "descend" ? (
              <SortAscendingOutlined />
            ) : sortOrder === "ascend" ? (
              <SortDescendingOutlined />
            ) : sortOrder === "descend" ? (
              <CloseCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            );
          },
          showSorterTooltip: { target: "full-header" },
          sorter: (a, b) => {
            if (cur.type === "date") {
              console.log("includes date");
              return (
                dayjs(a[`${cur.backendName}`]).unix() -
                dayjs(b[`${cur.backendName}`]).unix()
              );
            } else if (
              typeof (a[`${cur.backendName}`] ? a[`${cur.backendName}`] : 0) ===
              "number"
            ) {
              console.log("includes number");
              return a[`${cur.backendName}`] - b[`${cur.backendName}`];
            } else if (
              (a[`${cur.backendName}`]
                ? a[`${cur.backendName}`]
                : ""
              )?.includes("$")
            ) {
              console.log("includes dolalr");
              return (
                a[`${cur.backendName}`].replace("$", "").replace(",", "") -
                b[`${cur.backendName}`].replace("$", "").replace(",", "")
              );
            } else if (typeof a[`${cur.backendName}`] === "string") {
              return (
                a[`${cur.backendName}`] ? a[`${cur.backendName}`] : ""
              )?.localeCompare(
                b[`${cur.backendName}`] ? b[`${cur.backendName}`] : ""
              );
            }
          },
          sortDirections: ["ascend", "descend"],
        });
      } else if (cur.isDisplayed && cur.isSpecial) {
        columns.push({
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
        });
      } else if (cur.isDisplayed && cur.isFormatter) {
        const obj = createFormatter(cur);
        columns.push(obj);
      }
    }
    // console.log('Columns: ', columns);
    return columns;
  };

  const redirectFunc = (text) => {
    if (screen === "ManufacturerDashboard") {
      return <Link to={`/Manufacturer/${text}`}>{text}</Link>;
    } else if (screen === "AccountDashboard") {
      return <Link to={`/Account/${text}`}>{text}</Link>;
    } else if (screen === "AccountManufacturer") {
      return <Link to={`/Manufacturer/${text}`}>{text}</Link>;
    } else if (screen === "DistributorAccount") {
      return <Link to={`/Account/${text}`}>{text}</Link>;
    } else if (screen === "DistributorDashboard") {
      return <Link to={`/Distributor/${text}`}>{text}</Link>;
    } else if (screen === "ApprovalsDashboard") {
      return <Link to={`/DirectOrder/${text}`}>{text}</Link>;
    } else if (screen === "OrdersDashboard") {
      return <Link to={`/DirectOrder/${text}`}>{text}</Link>;
    } else if (screen === "InvoiceDashboard") {
      return (
        <></>
        // <Link to={`/DirectOrder/${text}`}>{text}</Link>
      );
    }
  };
  const viewFunc = (index, record) => {
    if (screen === "ManufacturerDashboard") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/Manufacturer/${record.ID}`}
            onClick={() => setLinkChange(true)}
          >
            View
          </Link>
        </Button>
      );
    } else if (screen === "ASUsersDashboard") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link to={`/User/${record.UserID ?? record.ID}`}>View</Link>
        </Button>
      );
    } else if (screen === "AccountUsers") {
      return (
        <>
          {record.RoleType === "Account" && (
            <Button type="primary" style={{ background: "#ff9202" }}>
              <Link to={`/User/${record.UserID ?? record.ID}`}>View</Link>
            </Button>
          )}
          {record.RoleType === "Contact" && (
            <Button type="primary" style={{ background: "#ff9202" }}>
              <Link to={`/User/${record.UserID ?? record.ID}`} state={"Contact"}>
                View
              </Link>
            </Button>
          )}
        </>
      );
    } else if (screen === "AccountUserDashboard") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link to={`/User/${record.UserID ?? record.ID}`}>View</Link>
        </Button>
      );
    } else if (screen === "DistributorUserDashboard") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link to={`/User/${record.UserID ?? record.ID}`}>View</Link>
        </Button>
      );
    } else if (screen === "DistributorHomeInvoiceTable") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/InvoiceHome/${record.ID}`}
            onClick={() => setLinkChange(true)}
          >
            View
          </Link>
        </Button>
      );
    } else if (screen === "AccountHomeInvoiceTable") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/InvoiceHome/${record.ID}`}
            onClick={() => setLinkChange(true)}
          >
            View
          </Link>
        </Button>
      );
    } else if (screen === "AccountDashboard") {
      return (
        // <Link to={`/Account/${text}`} >{text}</Link>
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/Account/${record.ID}`}
            onClick={() => setLinkChange(true)}
          >
            View
          </Link>
        </Button>
        // <Button type="primary" onClick={() => history.push(`/Account/${record.id}`)}>View</Button>
      );
    } else if (screen === "AccountManufacturer") {
      return (
        // <Link to={`/Manufacturer/${text}`}>{text}</Link>
        <>
          <Button type="primary" style={{ background: "#ff9202" }}>
            <Link
              to={`/Manufacturer/${record.ID}`}
              onClick={() => setLinkChange(true)}
            >
              View
            </Link>
          </Button>
          {userData.Type === "Admin" && hasPermission(userData, "manage_accounts.edit") && (
            <>
              {record.IsApproved === false && (
                <Button
                  type="primary"
                  style={{ background: "#27a907", marginLeft: "10px" }}
                  onClick={() => openManufacturerApproveModal(record)}
                >
                  Approve
                </Button>
              )}
              {record.IsApproved === true && (
                <Button
                  type="primary"
                  style={{ background: "#ff0000", marginLeft: "10px" }}
                  onClick={() => openManufacturerRemoveModal(record)}
                >
                  Remove
                </Button>
              )}
            </>
          )}
        </>
      );
    } else if (screen === "DistributorAccount") {
      return (
        <>
          {record.IsDistUserAssigned &&
            userType !== "User" &&
            userType !== "Viewer" && (
              <Button
                type="primary"
                onClick={() => handleChangeAssignmentModalOpen(record)}
                style={{ background: "#27a907", marginRight: "20px" }}
              >
                Change Assignment
              </Button>
            )}
          {record.IsDistUserAssigned === false && userType !== "Viewer" && (
            <Button
              type="primary"
              onClick={() => handleAssignAccountModalOpen(record)}
              style={{ background: "#ff0000", marginRight: "20px" }}
            >
              Assign
            </Button>
          )}
          <Button type="primary" style={{ background: "#ff9202" }}>
            <Link
              to={`/Account/${record.ID}`}
              onClick={() => setLinkChange(true)}
            >
              View
            </Link>
          </Button>
        </>
      );
    } else if (screen === "DistributorDashboard") {
      return (
        // <Link to={`/Distributor/${text}`}>{text}</Link>
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/Distributor/${record.ID}`}
            onClick={() => setLinkChange(true)}
          >
            View
          </Link>
        </Button>
      );
    } else if (screen === "ChildAccounts") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/Account/${record.ID}`}
            onClick={() => props.handleLinkChange()}
          >
            View
          </Link>
        </Button>
      );
    } else if (screen === "ApprovalsDashboard") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/DirectOrder/${record.ID}`}
            onClick={() => setLinkChange(true)}
          >
            View
          </Link>
        </Button>
      );
    } else if (screen === "OrdersDashboard") {
      return (
        <div style={{ display: "flex" }}>
          {(record.OrderType === "Direct Order" ||
            record.OrderType === "DO") && (
              <Button
                type="primary"
                style={{ background: "#ff9202", marginRight: "10px" }}
              >
                <Link
                  to={`/DirectOrder/${record.ID}`}
                  onClick={() => setLinkChange(true)}
                >
                  View
                </Link>
              </Button>
            )}
          {(record.OrderType === "Consignment Order" ||
            record.OrderType === "CO") && (
              <Button
                type="primary"
                style={{ background: "#ff9202", marginRight: "10px" }}
              >
                <Link
                  to={`/ConsignmentOrder/${record.ID}`}
                  onClick={() => setLinkChange(true)}
                >
                  View
                </Link>
              </Button>
            )}
          {(record.OrderType === "Product Usage" ||
            record.OrderType === "PU") && (
              <Button
                type="primary"
                style={{ background: "#ff9202", marginRight: "10px" }}
              >
                <Link
                  to={`/ProductUsage/${record.ID}`}
                  onClick={() => setLinkChange(true)}
                >
                  View
                </Link>
              </Button>
            )}
          {record.IsInvoiceGenerated && (
            <Button
              type="primary"
              style={{
                color: "#ff9202",
                borderColor: "#ff9202",
                background: "transparent",
              }}
            >
              <Link
                to={`/InvoiceHome/${record.InvoiceID}`}
                onClick={() => setLinkChange(true)}
              >
                {record.OrderType !== "Consignment Order" && <>View Invoice</>}
                {record.OrderType === "Consignment Order" && <>View Details</>}
              </Link>
            </Button>
          )}

          {record.IsInvoiceGenerated === false &&
            record.OrderStatus !== "Pending" &&
            userData.Type === "Admin" && (
              <Button
                type="primary"
                onClick={() => openInvoiceModal(record)}
                style={{ background: colors["primaryColor"] }}
              >
                Add Details
              </Button>
            )}
        </div>
      );
    } else if (screen === "InvoiceDashboard") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/InvoiceHome/${record.ID}`}
            onClick={() => setLinkChange(true)}
          >
            View
          </Link>
        </Button>
      );
    } else if (screen === "InvoiceHomeOrderProducts") {
      return (
        <>
          {userData.Type === "Admin" && (
            <Button
              type="primary"
              style={{ background: "#ff9202" }}
              onClick={() => handleInvoiceHomeOrderProductsEdit(record)}
            >
              View
            </Button>
          )}
        </>
      );
    } else if (screen === "InvoiceHomeOrderDetails") {
      return (
        <div>
          {(record.OrderType === "DO" ||
            record.OrderType === "Direct Order") && (
              <Button type="primary" style={{ background: "#ff9202" }}>
                <Link
                  to={`/DirectOrder/${record.ID}`}
                  onClick={() => setLinkChange(true)}
                >
                  View
                </Link>
              </Button>
            )}
          {(record.OrderType === "CO" ||
            record.OrderType === "Consignment Order") && (
              <Button type="primary" style={{ background: "#ff9202" }}>
                <Link
                  to={`/ConsignmentOrder/${record.ID}`}
                  onClick={() => setLinkChange(true)}
                >
                  View
                </Link>
              </Button>
            )}
        </div>
      );
    } else if (screen === "IVRSubmissions") {
      return (
        <Button type="primary" style={{ background: "#ff9202" }}>
          <Link
            to={`/IVRManufacturers/${record.ID}`}
            onClick={() => setLinkChange(true)}
          >
            View
          </Link>
        </Button>
      );
    } else if (screen === "IVRManufacturers") {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <Button type="primary" style={{ background: "#ff9202" }}>
            <Link
              to={`/ViewIVRManufacturer/${record.ID}`}
              onClick={() => setLinkChange(true)}
            >
              View
            </Link>
          </Button>
          {record?.AzureBlobName && (
            <DownloadOutlined
              style={{ fontSize: "24px", marginLeft: "16px" }}
              onClick={() => handleDownload(record)}
            />
          )}
        </div>
      );
    } else if (screen === "AccountProductLog") {
      return (
        <>
          {/* <Button
            type='primary'
            style={{
              color: '#ff9202',
              borderColor: '#ff9202',
              background: 'transparent',
              marginRight: '10px'
            }}>
            {record.OrderType === "Direct Order" &&
              <Link to={`/DirectOrder/${record.OrderID}`} onClick={() => setLinkChange(true)}>View PO</Link>
            }
            {record.OrderType === "Product Usage" &&
              <Link to={`/ProductUsage/${record.OrderID}`} onClick={() => setLinkChange(true)}>View PO</Link>
            }
          </Button> */}
          <Button
            type="primary"
            style={{
              color: "#ff9202",
              borderColor: "#ff9202",
              background: "transparent",
            }}
          >
            <Link
              to={`/InvoiceHome/${record.InvoiceID}`}
              onClick={() => setLinkChange(true)}
            >
              View Invoice
            </Link>
          </Button>
          {record.OrderType === "Direct Order" && userType !== "Viewer" && (
            <EditOutlined
              style={{ fontSize: "20px", marginLeft: "10px" }}
              onClick={() => openEditOrderModal(record)}
            />
          )}
        </>
      );
    }
  };

  const [showEditOrderModal, setShowEditOrderModal] = React.useState(false);

  const handleDownloadAccountProductLog = (record) => {
    console.log("Record: ", record);
    console.log("Data: ", record.TissueTrackingFile.data);
    const arrayBuffer = record.TissueTrackingFile.data;
    const bytes = new Uint8Array(arrayBuffer);
    const blob = new Blob([bytes], { type: "application/pdf" });

    const url = window.URL.createObjectURL(blob);

    // Create a link element and trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", record.TissueTrackingFileName); // Set the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = async (record) => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(record.AzureBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }

    // download the file from Azure Blob Storage
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // console.log("Record: ", record);
    // console.log("Data: ", record.UploadedFile.data);
    // const arrayBuffer = record.UploadedFile.data;
    // const bytes = new Uint8Array(arrayBuffer);
    // const blob = new Blob([bytes], { type: "application/pdf" });

    // const url = window.URL.createObjectURL(blob);

    // // Create a link element and trigger the download
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", record.FileName); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const createFormatter = (cur) => {
    switch (cur.formatterType) {
      case "redirect": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (text) => redirectFunc(text),
        };
      }
      case "childAccountAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => (
            <Button type="primary" style={{ background: "#ff9202" }}>
              <Link
                to={`/Account/${record.ID}`}
                onClick={() => props.handleLinkChange()}
              >
                View
              </Link>
            </Button>
          ),
        };
      }
      case "redirectButton": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => viewFunc(index, record),
        };
      }
      case "toggle": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (text) => {
            if (text) {
              return "Active";
            } else {
              return "Inactive";
            }
          },
        };
      }
      case "modalButtonApprovalsDashboard": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          // render: (index, record) => <button onClick={() => openApproveModal(record)}>Approve</button>,
          render: (index, record) => {
            return (
              <div
                style={{ display: "flex", gap: "10px", justifyContent: "end" }}
              >
                <Button type="primary" style={{ background: "#ff9202" }}>
                  {record.OrderType === "Product Usage" && (
                    <Link
                      to={`/ProductUsage/${record.ID}`}
                      onClick={() => setLinkChange(true)}
                    >
                      View
                    </Link>
                  )}
                  {record.OrderType === "Consignment Order" && (
                    <Link
                      to={`/ConsignmentOrder/${record.ID}`}
                      onClick={() => setLinkChange(true)}
                    >
                      View
                    </Link>
                  )}
                  {(record.OrderType === "Direct Order" ||
                    record.OrderType === "DO") && (
                      <Link
                        to={`/DirectOrder/${record.ID}`}
                        onClick={() => setLinkChange(true)}
                      >
                        View
                      </Link>
                    )}
                </Button>
                <Button
                  type="primary"
                  style={{ background: "#27a907" }}
                  onClick={() => openApproveModal(record)}
                >
                  Approve
                </Button>
              </div>
            );
          },
        };
      }
      case "modalButtonConsignmentLog": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                {/* <Button
                  type='primary'
                  style={{
                    color: '#ff9202',
                    borderColor: '#ff9202',
                    background: 'transparent',
                  }}
                  onClick={()=>navigate('/ProductUsage', { state: { 
                    IsRedirected: true,
                    ManufacturerID: record.ManufacturerID, 
                    ManufacturerName: record.ManufacturerName,  
                    AccountID: record.AccountID,
                    AccountName: record.AccountName,
                    Price: record.Price,
                    ProductCode: record.ProductCode,
                    ProductName: record.ProductName,
                    TissueID: record.TissueID,
                  } })}
                >Create Product Usage</Button> */}
                <Button
                  type="primary"
                  style={{ background: "#ff9202" }}
                  onClick={() => handleConsignmentModalOpen(record)}
                >
                  View Log
                </Button>
              </div>
            );
          },
        };
      }
      case "ordersAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div
                style={{ display: "flex", gap: "10px", justifyContent: "end" }}
              >
                <Button type="primary" style={{ background: "#ff9202" }}>
                  <Link
                    to={`/Orders/${record.ID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View
                  </Link>
                </Button>
              </div>
            );
          },
        };
      }
      case "viewProduct": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div
                style={{ display: "flex", gap: "10px", justifyContent: "end" }}
              >
                <Button
                  type="primary"
                  style={{ background: "#ff9202" }}
                  onClick={() => openViewProductModal(record)}
                >
                  View
                </Button>
              </div>
            );
          },
        };
      }
      case "invoiceDashboardAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div>
                <button>
                  <Link
                    to={`/InvoiceHome/${record.ID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View
                  </Link>
                </button>
              </div>
            );
          },
        };
      }
      case "invoiceHomeOrderDetailsAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div>
                {record.OrderType === "DO" && (
                  <button>
                    <Link
                      to={`/DirectOrder/${record.ID}`}
                      onClick={() => setLinkChange(true)}
                    >
                      View
                    </Link>
                  </button>
                )}
                {record.OrderType === "CO" && (
                  <button>
                    <Link
                      to={`/Consignment/${record.ID}`}
                      onClick={() => setLinkChange(true)}
                    >
                      View
                    </Link>
                  </button>
                )}
              </div>
            );
          },
        };
      }
      case "ivrSubmissionAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div>
                <button>
                  <Link
                    to={`/IVRManufacturers/${record.ID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View
                  </Link>
                </button>
              </div>
            );
          },
        };
      }
      case "productLogAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div>
                <button>
                  <Link
                    to={`/DirectOrder/${record.DirectOrderID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View PO
                  </Link>
                </button>
                <button>
                  <Link
                    to={`/InvoiceHome/${record.InvoiceID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View Invoice
                  </Link>
                </button>
              </div>
            );
          },
        };
      }
      case "ivrManufacturersAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div>
                <button>
                  <Link
                    to={`/AddIVRManufacturer/${record.IVRID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View
                  </Link>
                </button>
              </div>
            );
          },
        };
      }
      case "manufacturerAccountDashboardAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div>
                <button>
                  <Link
                    to={`/Account/${record.ID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View
                  </Link>
                </button>
              </div>
            );
          },
        };
      }
      case "accountUsersAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div>
                <Button type="primary" style={{ background: "#ff9202" }}>
                  <Link
                    to={`/User/${record.ID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View
                  </Link>
                </Button>
              </div>
            );
          },
        };
      }
      case "accountManufacturerAction": {
        return {
          title: cur.displayName,
          dataIndex: cur.backendName,
          key: cur.backendName,
          render: (index, record) => {
            return (
              <div>
                <Button type="primary" style={{ background: "#ff9202" }}>
                  <Link
                    to={`/Manufacturer/${record.ID}`}
                    onClick={() => setLinkChange(true)}
                  >
                    View
                  </Link>
                </Button>
              </div>
            );
          },
        };
      }
    }
  };

  const openEditOrderModal = (record) => {
    console.log("Edit Product Log Modal Opened: ", record);
    setOrderData(record);
    setShowEditOrderModal(true);
  };

  const openInvoiceModal = (record) => {
    // console.log("Invoice Modal Opened: ", record);

    setOrderData(record);
    setShowInvoiceModal(true);
  };

  const [showInvoiceModal, setShowInvoiceModal] = React.useState(false);
  const [orderData, setOrderData] = React.useState(null);

  const [showApproveModal, setShowApproveModal] = React.useState(false);
  const [modalData, setModalData] = React.useState({});

  const location = useLocation();
  const manufacturerIdFromUrl = location.pathname.split("/")[2];

  const openApproveModal = (record) => {
    // console.log("Approve Modal Opened: ", record);
    setModalData(record);
    setShowApproveModal(true);
  };

  const handleCancel = () => {
    // console.log('Clicked cancel button');
    setShowApproveModal(false);
    setShowInvoiceModal(false);
  };

  const [showLoader, setShowLoader] = React.useState(false);

  const [confirmLoading, setConfirmLoading] = React.useState(false);

  const handleOk = async (record) => {
    setShowApproveModal(false);
    setShowLoader(true);
    setConfirmLoading(true);
    // approve order
    const apiServe = new APIService();
    const postObj = {
      ID: modalData.ID,
      Status: "Approved",
      ApprovedBy:
        userData.FirstName + " " + userData.LastName,
      // ApprovedDate: moment().format("MM-DD-YYYY HH:mm:ss"),
      ApprovedDate: dayjs(),
    };
    let response = null;
    if (
      modalData.OrderType === "Direct Order" ||
      modalData.OrderType === "DO"
    ) {
      response = await apiServe.updateDataToBackend(
        postObj,
        `updatedirectorder?type=approve`
      );
    } else if (
      modalData.OrderType === "Consignment Order" ||
      modalData.OrderType === "CO"
    ) {
      response = await apiServe.updateDataToBackend(
        postObj,
        `updateconsignmentorder?type=approve`
      );
    } else if (
      modalData.OrderType === "Product Usage" ||
      modalData.OrderType === "PU"
    ) {
      response = await apiServe.updateDataToBackend(
        postObj,
        `updateproductusageorder?type=approve`
      );
    }
    // console.log("Approve Order Response: ", response);
    setConfirmLoading(false);
    setShowApproveModal(false);
    Swal.fire("Approved!", "Order Successfully Approved.", "success").then(
      () => {
        window.location.reload();
      }
    );
  };

  const openViewProductModal = (record) => {
    // console.log("View Product Modal Opened: ", record);
    setInitialProductValues(record);
    setProductData(record);
    setShowViewProductModal(true);
  };

  const [showViewProductModal, setShowViewProductModal] = React.useState(false);
  const [productData, setProductData] = React.useState(null);
  const [initialProductValues, setInitialProductValues] = React.useState(null);
  const [accountDiscountValue, setAccountDiscountValue] = useState(0);
  const [approvalDefaultStrategy, setApprovalDefaultStrategy] = useState(null);
  const [approvalProductGroups, setApprovalProductGroups] = useState([]);
  const [approvalPricingLoading, setApprovalPricingLoading] = useState(false);
  const [approvalPricingLoaded, setApprovalPricingLoaded] = useState(false);
  const [approvalSubmitting, setApprovalSubmitting] = useState(false);
  const [approvalError, setApprovalError] = useState("");
  const [newDpaFile, setNewDpaFile] = React.useState(null);
  const [newDpaFileName, setNewDpaFileName] = React.useState("");
  const [uploadFileList, setUploadFileList] = React.useState([]);

  const pricingStrategyOptions = [
    { value: "discount", label: "Discount-Based" },
    { value: "custom", label: "Custom Price" },
  ];

  const isValidDiscount = (value) => {
    const text = String(value ?? "").trim();
    if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return false;
    const number = Number(text);
    return Number.isFinite(number) && number >= 0 && number <= 100;
  };

  const handleProductDelete = async (record) => {
    console.log("Product Values:", record);
    // return;
    const apiServe = new APIService();
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this product?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await apiServe.updateDataToBackend(
            record,
            "updateproduct?type=delete"
          );
          console.log("Delete response:", response);
          if (response?.status === 200 || response?.status === 201) {
            Swal.fire(
              "Success!",
              "Product Deleted Successfully.",
              "success"
            ).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire("Error!", "Error deleting product.", "error");
          }
        }
      });
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  const handleProductSubmit = async (values) => {
    console.log("Product Values:", values);
    // return;
    const apiServe = new APIService();
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to save these changes?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await apiServe.updateDataToBackend(
            values,
            "updateproduct?type=edit"
          );
          console.log("Update response:", response);
          if (response?.status === 200 || response?.status === 201) {
            Swal.fire(
              "Success!",
              "Product Updated Successfully.",
              "success"
            ).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire("Error!", "Error updating product.", "error");
          }
        }
      });
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  const [showModalConsignment, setShowModalConsignment] = React.useState(false);
  const [consignmentModalData, setConsignmentModalData] = React.useState(null);

  const handleConsignmentModalOpen = (record) => {
    console.log("Consignment Modal Opened: ", record);
    setConsignmentModalData(record);
    setShowModalConsignment(true);
  };

  const handleDeleteConsignmentProduct = async () => {
    setShowLoader(true);
    console.log("Consignment Modal Delete Product");
    console.log("Consignment Modal Data: ", consignmentModalData);
    const apiServe = new APIService();
    // delete consignment product
    const postObj = {
      OrderID: consignmentModalData.OrderID,
      ProductID: consignmentModalData.ProductID,
      InvoiceID: consignmentModalData.InvoiceID,
      TissueID: consignmentModalData.TissueID,
    };
    const response = await apiServe.updateDataToBackend(
      postObj,
      "deleteconsignmentlogproduct"
    );
    console.log("Delete Consignment Product Response: ", response);
    if (response?.status === 200 || response?.status === 201) {
      setShowLoader(false);
      setShowModalConsignment(false);
      Swal.fire(
        "Deleted!",
        "Consignment Product Deleted Successfully.",
        "success"
      ).then(() => {
        window.location.reload();
      });
    } else {
      setShowLoader(false);
      Swal.fire("Error!", "Error deleting consignment product.", "error");
    }
  };
  const handleCancelConsignment = () => {
    setShowModalConsignment(false);
  };

  const [showAssignAccountModal, setShowAssignAccountModal] =
    React.useState(false);
  const [assignAccountData, setAssignAccountData] = React.useState(null);

  const handleOkAssignAccount = () => {
    console.log("Assign Account Modal Delete Product");
    setShowAssignAccountModal(false);
  };

  const handleCancelAssignAccount = () => {
    setShowAssignAccountModal(false);
  };

  const handleAssignAccountModalOpen = (record) => {
    console.log("Assign Account Modal Opened: ", record);
    setAssignAccountData(record);
    setShowAssignAccountModal(true);
  };

  const [changeAssignmentModal, setChangeAssignmentModal] =
    React.useState(false);
  const [changeAssignmentData, setChangeAssignmentData] = React.useState(null);

  const handleOkChangeAssignment = () => {
    console.log("Change Assignment Modal Delete Product");
    setChangeAssignmentModal(false);
  };

  const handleCancelChangeAssignment = () => {
    setChangeAssignmentModal(false);
  };

  const handleChangeAssignmentModalOpen = (record) => {
    console.log("Change Assignment Modal Opened: ", record);
    setChangeAssignmentData(record);
    setChangeAssignmentModal(true);
  };

  const [showManufacturerApproveModal, setShowManufacturerApproveModal] =
    React.useState(false);
  const [manApproveModalData, setManApproveModalData] = React.useState({});

  const openManufacturerApproveModal = async (record) => {
    console.log("Manufacturer Approve Modal Opened: ", record);
    setManApproveModalData(record);
    setShowManufacturerApproveModal(true);
    setApprovalDefaultStrategy(null);
    setApprovalProductGroups([]);
    setAccountDiscountValue(0);
    setApprovalError("");
    setNewDpaFile(null);
    setUploadFileList([]);
    setApprovalPricingLoading(true);
    setApprovalPricingLoaded(false);
    try {
      const accountID = Number(record?.AccountID);
      const manufacturerID = Number(record?.ManufacturerID ?? record?.ID);
      if (!Number.isInteger(accountID) || accountID <= 0 ||
          !Number.isInteger(manufacturerID) || manufacturerID <= 0) {
        throw new Error("The selected account/manufacturer relationship has invalid identifiers.");
      }
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        `manufacturerapprovalpricingoptions?AccountID=${accountID}&ManufacturerID=${manufacturerID}`,
      );
      const options = response?.data?.data || {};
      const defaultDiscount = options.DefaultDiscountPercentage ?? 0;
      const productGroups = Array.isArray(options.ProductGroups)
        ? options.ProductGroups
        : [];
      setAccountDiscountValue(defaultDiscount);
      setApprovalProductGroups(
        productGroups.map((group) => ({
          ...group,
          CustomPricing: true,
          DiscountPercentage: 0,
          inheritsStrategy: false,
          inheritsDiscount: true,
        })),
      );
      setApprovalPricingLoaded(true);
    } catch (error) {
      setApprovalError(
        error?.response?.data?.error || error?.message || "Unable to load manufacturer pricing options.",
      );
    } finally {
      setApprovalPricingLoading(false);
    }
  };

  const handleApprovalDefaultStrategy = (option) => {
    setApprovalDefaultStrategy(option);
    setApprovalProductGroups((groups) =>
      groups.map((group) => ({
        ...group,
        // The account-manufacturer strategy is only the default for future
        // product groups. Existing groups shown during approval start with
        // Apply Discount off and can be opted in individually.
        CustomPricing: true,
        DiscountPercentage: 0,
        inheritsStrategy: false,
        inheritsDiscount: true,
      })),
    );
  };

  const handleDefaultDiscountChange = (value) => {
    setAccountDiscountValue(value);
    setApprovalProductGroups((groups) =>
      groups.map((group) =>
        !group.CustomPricing && group.inheritsDiscount
          ? { ...group, DiscountPercentage: value }
          : group,
      ),
    );
  };

  const handleApprovalGroupMode = (productGroupID, applyDiscount) => {
    setApprovalProductGroups((groups) =>
      groups.map((group) =>
        group.ID === productGroupID
          ? {
              ...group,
              CustomPricing: !applyDiscount,
              DiscountPercentage: applyDiscount ? accountDiscountValue : 0,
              inheritsStrategy: false,
              inheritsDiscount: applyDiscount,
            }
          : group,
      ),
    );
  };

  const handleApprovalGroupDiscount = (productGroupID, value) => {
    setApprovalProductGroups((groups) =>
      groups.map((group) =>
        group.ID === productGroupID
          ? { ...group, DiscountPercentage: value, inheritsDiscount: false }
          : group,
      ),
    );
  };

  const approvalFormValid =
    approvalPricingLoaded &&
    newDpaFile &&
    approvalDefaultStrategy &&
    isValidDiscount(accountDiscountValue) &&
    approvalProductGroups.every(
      (group) => group.CustomPricing || isValidDiscount(group.DiscountPercentage),
    );

  const downloadDPAFile = async (record) => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(record.DPAAzureBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }
    // download the file from Azure Blob Storage
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOkApproveManufacturer = async () => {
    if (readOnly || !approvalFormValid || approvalSubmitting) return;
    console.log("Approve Manufacturer Data: ", manApproveModalData);
    setApprovalSubmitting(true);
    setApprovalError("");
    // approve manufacturer
    const apiServe = new APIService();
    const formData = new FormData();
    const postObj = {
      AccountID: manApproveModalData.AccountID,
      ManufacturerID: manApproveModalData.ID,
      DefaultDiscountPercentage: accountDiscountValue,
      CustomPricing: approvalDefaultStrategy.value === "custom",
      ProductGroups: approvalProductGroups.map((group) => ({
        ProductGroupID: group.ID,
        CustomPricing: group.CustomPricing,
        DiscountPercentage: group.CustomPricing ? null : group.DiscountPercentage,
      })),
    };
    const stringifiedPostObj = JSON.stringify(postObj);
    formData.append("file", newDpaFile);
    formData.append("data", stringifiedPostObj);
    try {
      const response = await apiServe.addFileDataToBackend(
        formData,
        "approvemanufacturer",
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      console.log("Approve Manufacturer Response: ", response);
      setShowManufacturerApproveModal(false);
      Swal.fire("Approved!", "Manufacturer Approved Successfully.", "success").then(() => {
        window.location.reload();
      });
    } catch (error) {
      setApprovalError(
        error?.response?.data?.error || "Unable to approve this manufacturer.",
      );
    } finally {
      setApprovalSubmitting(false);
    }
  };

  const handleCancelApproveManufacturer = () => {
    // console.log('Clicked cancel button');
    setShowManufacturerApproveModal(false);
    setManApproveModalData({});
    setApprovalError("");
    setApprovalDefaultStrategy(null);
    setApprovalProductGroups([]);
    setNewDpaFile(null);
    setUploadFileList([]);
    setApprovalPricingLoaded(false);
  };

  const [showManufacturerRemoveModal, setShowManufacturerRemoveModal] =
    React.useState(false);

  const [
    showAccountManufacturerRemoveModal,
    setShowAccountManufacturerRemoveModal,
  ] = React.useState(false);

  const [manRemoveModalData, setManRemoveModalData] = React.useState({});

  const openManufacturerRemoveModal = (record) => {
    console.log("Manufacturer Approve Modal Opened: ", record);
    setManRemoveModalData(record);
    setShowManufacturerRemoveModal(true);
  };

  const handleOkRemoveManufacturer = async () => {
    console.log("Remove Manufacturer Data: ", manRemoveModalData);
    setShowManufacturerRemoveModal(false);
    setShowLoader(true);
    // approve manufacturer
    const apiServe = new APIService();
    const postObj = {
      AccountID: manRemoveModalData.AccountID,
      ManufacturerID: manRemoveModalData.ID,
    };
    const response = await apiServe.updateDataToBackend(
      postObj,
      "removemanufacturer"
    );
    console.log("Remove Manufacturer Response: ", response);
    setShowLoader(false);
    Swal.fire("Removed!", "Manufacturer Removed Successfully.", "success").then(
      () => {
        window.location.reload();
      }
    );
  };

  const handleOkRemoveAccountManufacturer = async () => {
    if (readOnly) return;
    console.log("Remove Account Data: ", manRemoveModalData);

    setShowAccountManufacturerRemoveModal(false);
    setShowLoader(true);
    // approve manufacturer
    const apiServe = new APIService();
    const postObj = {
      AccountID: manRemoveModalData.ID,
      ManufacturerID: manufacturerIdFromUrl,
    };
    const response = await apiServe.updateDataToBackend(
      postObj,
      "removemanufacturer"
    );
    console.log("Remove Account Response: ", response);
    setShowLoader(false);
    Swal.fire("Removed!", "Account Removed Successfully.", "success").then(
      () => {
        window.location.reload();
      }
    );
  };

  const handleCancelRemoveManufacturer = () => {
    // console.log('Clicked cancel button');
    setShowManufacturerRemoveModal(false);
    setManRemoveModalData({});
  };

  const handleCancelRemoveAccountManufacturer = () => {
    // console.log('Clicked cancel button');
    setShowAccountManufacturerRemoveModal(false);
    setManRemoveModalData({});
  };

  const [
    openInvoiceHomeOrderProductsEdit,
    setOpenInvoiceHomeOrderProductsEdit,
  ] = React.useState(false);
  const [
    invoiceHomeOrderProductsEditData,
    setInvoiceHomeOrderProductsEditData,
  ] = React.useState(null);

  const handleInvoiceHomeOrderProductsEdit = (record) => {
    console.log("Invoice Home Order Products Edit: ", record);
    setOpenInvoiceHomeOrderProductsEdit(true);
    setInvoiceHomeOrderProductsEditData(record);
  };

  React.useEffect(() => {
    console.log("GenDash Props: ", props);
    setColumns(generateSchema(screen));
  }, [linkChange, searchKeyword]);

  const nonPaginatedScreens = [
    "DistributorAccount",
    "DistributorUser",
    "ManufacturerProduct",
    "AccountManufacturer",
    "InvoiceHomeOrderDetails",
    "InvoiceHomeOrderProducts",
    "ChildAccounts",
  ];
  const shouldPaginate = !nonPaginatedScreens.includes(screen);

  const tableOnChange = (pagination, filters, sorter, extra) => {
    // console.log('params', pagination, filters, sorter, extra);
    // console.log('Sorted Info: ', sorter);
    // console.log('Filtered Info: ', filters);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  // const handleSearch = (value) => {
  //   console.log('Search Value: ', value);
  //   setSearchKeyword(value);
  // }

  const handleAssignClick = (row) => {
    setAssignAccountData(row);
    setShowAssignAccountModal(true);
  };

  const handleRemoveAccountUserFromDistributor = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to remove this Sales Rep from this account?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const postObj = {
          AccountID: row.ID,
          DistributorID: row.DistributorID,
        };
        const response = await apiServe.updateDataToBackend(
          postObj,
          "updateaccount?type=RemoveDistributorUser"
        );
        console.log("Remove Dist User Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire(
            "Removed!",
            "Distributor User Removed Successfully.",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire("Error!", "Error removing distributor user.", "error");
        }
      }
    });
  };

  const handleDeleteClick = (row) => {
    setManRemoveModalData(row);
    setShowManufacturerRemoveModal(true);
  };

  const handleDeleteAccountManufacturerClick = (row) => {
    if (readOnly) return;
    setManRemoveModalData(row);
    setShowAccountManufacturerRemoveModal(true);
  };

  const getTableHeadersDistributorAccount = (handleAssignClick) =>
    (userData.Type === "Admin" ||
      (userData.Type === "Distributor" && userData.IsManager)) &&
      hasPermission(userData, "manage_distributors.edit")
      ? [
        {
          headerName: "Account Name",
          field: "AccountName",
          minWidth: 150,
          maxWidth: 180,
          cellRenderer: (params) => (
            <TableLink
              value={params.data.AccountName}
              path={`/Account/${params.data.ID}`}
            />
          ),
        },
        {
          headerName: "Region",
          field: "RegionName",
          minWidth: 115,
          maxWidth: 130,
        },
        {
          headerName: "Assigned To",
          field: "DistributorUsername",
          minWidth: 115,
          maxWidth: 130,
        },
        {
          headerName: "Action",
          field: "",
          width: 120,
          minWidth: 120,
          maxWidth: 130,
          cellRenderer: (params) => (
            <TableOptionsCell
              optionOne={params.data.IsDistUserAssigned ? "Remove" : "Assign"}
              optionOneType={
                params.data.IsDistUserAssigned ? "failure" : "success"
              }
              optionOneClickFn={
                !params.data.IsDistUserAssigned
                  ? () => handleAssignClick(params.data)
                  : () => handleRemoveAccountUserFromDistributor(params.data)
              }
              rowData={params.data}
            />
          ),
        },
      ]
      : [
        {
          headerName: "Account Name",
          field: "AccountName",
          minWidth: 150,
          maxWidth: 180,
          cellRenderer: (params) => (
            <TableLink
              value={params.data.AccountName}
              path={`/Account/${params.data.ID}`}
            />
          ),
        },
        {
          headerName: "Region",
          field: "RegionName",
          minWidth: 115,
          maxWidth: 130,
        },
        {
          headerName: "Assigned To",
          field: "DistributorUsername",
          minWidth: 115,
          maxWidth: 130,
        },
      ];

  const tableHeadersDistributorAccount =
    getTableHeadersDistributorAccount(handleAssignClick);

  const getTableHeadersAccountManufacturer = (
    handleDeleteClick,
    handleAccountManufacturerApproveModal
  ) =>
    (userData.Type === "Admin" || (["ASD", "Authorizer", "Viewer"].includes(userData.Type) && hasPermission(userData, "manage_accounts.edit"))) && !readOnly
      ? [
        {
          headerName: "Manufacturer Name",
          field: "ManufacturerName",
          filter: true,
        },
        {
          headerName: "Status",
          field: "Status",
          filter: true,
          cellRenderer: (params) => {
            return params.data.IsApproved ? "Approved" : "Pending";
          },
        },
        {
          headerName: "Approved By",
          field: "ApprovedByUserName",
          filter: true,
        },
        {
          headerName: "DPA",
          field: "DPAFile",
          filter: false,
          cellRenderer: (params) =>
            params.data?.DPAAzureBlobName ? (
              <DownloadOutlined
                style={{ fontSize: "20px", cursor: "pointer" }}
                onClick={() => downloadDPAFile(params.data)}
              />
            ) : (
              "N/A"
            ),
          minWidth: 90,
        },
        {
          headerName: "Action",
          field: "",
          minWidth: 260,
          cellRenderer: (params) => (
            <TableOptionsCell
              optionOne={userData.Type === "Admin" ? (params.data.IsApproved ? "Remove" : "Approve") : undefined}
              optionOneType={params.data.IsApproved ? "failure" : "success"}
              optionOneClickFn={
                params.data.IsApproved
                  ? () => handleDeleteClick(params.data)
                  : () => handleAccountManufacturerApproveModal(params.data)
              }
              rowData={params.data}
              optionTwo={canAttachDpa({ user, isReady, readOnly, row: params.data, account: additionalData }) ? "Attach DPA" : undefined}
              optionTwoClickFn={() => {
                if (canAttachDpa({ user, isReady, readOnly, row: params.data, account: additionalData })) setAttachDpaRow(params.data);
              }}
            />
          ),
        },
      ]
      : [
        {
          headerName: "Manufacturer Name",
          field: "ManufacturerName",
          filter: true,
        },
        {
          headerName: "Status",
          field: "Status",
          filter: true,
          cellRenderer: (params) => {
            return params.data.IsApproved ? "Approved" : "Pending";
          },
        },
        {
          headerName: "Approved By",
          field: "ApprovedByUserName",
          filter: true,
        },
        {
          headerName: "DPA",
          field: "DPAFile",
          filter: false,
          cellRenderer: (params) =>
            params.data?.DPAAzureBlobName ? (
              <DownloadOutlined
                style={{ fontSize: "20px", cursor: "pointer" }}
                onClick={() => downloadDPAFile(params.data)}
              />
            ) : (
              "N/A"
            ),
          minWidth: 90,
        },
      ];

  const tableHeadersAccountManufacturer = getTableHeadersAccountManufacturer(
    handleDeleteClick,
    openManufacturerApproveModal
  );

  const handleApproveClick = (row) => {
    setModalData(row);
    setShowApproveModal(true);
  };

  const getTableHeadersApprovalsDashboard = (handleApproveClick) => [
    {
      headerName: "Order Date",
      field: "OrderDate",
      filter: true,
    },

    {
      headerName: "PO Number",
      field: "PONumber",
      isSearchable: true,
      filter: true,
      cellRenderer: (params) => {
        const orderType = params.data.OrderType.split(" ").join("");
        return (
          <TableLink
            value={params.data.PONumber}
            path={`/${orderType}/${params.data.ID}`}
          />
        );
      },
    },
    {
      headerName: "Account",
      field: "AccountName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.AccountName}
          path={`/Account/${params.data.AccountID}`}
        />
      ),
    },
    {
      headerName: "Manufacturer",
      field: "ManufacturerName",
      filter: true,
    },
    {
      headerName: "Order Type",
      field: "OrderType",
      filter: true,
    },
    {
      headerName: "Order Total",
      field: "OrderTotal",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params.data.OrderTotal).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.OrderTotal).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Action",
      field: "",

      cellRenderer: (params) => {
        const canManageOrder = hasPermission(userData, "order.manage");
        const action = getApprovalRowAction({
          order: params?.data,
          approvalTabType,
          canManageOrder,
        });

        return (
          <TableOptionsCell
            optionOne={action?.label}
            optionOneType={action?.type}
            optionOneClickFn={
              action?.kind === "fulfill"
                ? () => openInvoiceModal(params.data)
                : action?.kind === "approve"
                ? () => handleApproveClick(params.data)
                : undefined
            }
            optionOneClickPath={
              action?.kind === "view" ? action.path : undefined
            }
            rowData={params.data}
          />
        );
      },
    },
  ];

  const tableHeadersApprovalsDashboard =
    getTableHeadersApprovalsDashboard(handleApproveClick);

  const handleEditProductDetails = (row) => {
    setOrderData(row);
    setShowEditOrderModal(true);
  };

  const getTableHeadersAccountProductLogScreen = (
    handleEditProductDetails,
    handleDownloadAccountProductLog
  ) => [
      {
        headerName: "Invoice Number",
        field: "InvoiceNumber",
        filter: true,
        cellRenderer: (params) => (
          <TableLink
            value={params.data.InvoiceNumber}
            path={`/InvoiceHome/${params.data.InvoiceID}`}
          />
        ),
      },
      {
        headerName: "TissueID",
        field: "TissueID",
        filter: true,
        // cellRenderer: (params) => (
        //   <TableLink
        //     value={params.data.TissueID}
        //     path={`/InvoiceHome/${params.data.InvoiceID}`}
        //   />
        // ),
      },
      {
        headerName: "Product Code",
        field: "ProductCode",
        filter: true,
      },
      {
        headerName: "Patient",
        field: "Patient",
        filter: true,
      },
      {
        headerName: "ApplicationDate",
        field: "ApplicationDate",
        filter: true,
      },
      {
        headerName: "Application #",
        field: "ApplicationNumber",
        filter: true,
      },
      {
        headerName: "Cost",
        field: "Cost",
        filter: true,

        cellRenderer: (params) => <div>${params.data.Cost}</div>,
      },
      {
        headerName: "User Actions",
        field: "",
        cellRenderer: (params) =>
          params.data?.TissueTrackingFile &&
            params.data?.TissueTrackingFile?.data ? (
            <TableOptionsCell
              optionTwo="Edit"
              optionTwoType="primary"
              optionThree="Download"
              optionThreeType="success"
              optionTwoClickFn={() => handleEditProductDetails(params.data)}
              optionThreeClickFn={() =>
                handleDownloadAccountProductLog(params.data)
              }
            />
          ) : (
            <TableOptionsCell
              optionTwo="Edit"
              optionTwoType="primary"
              optionTwoClickFn={() => handleEditProductDetails(params.data)}
            />
          ),
      },
    ];

  const tableHeadersAccountProductLogScreen =
    getTableHeadersAccountProductLogScreen(
      handleEditProductDetails,
      handleDownloadAccountProductLog
    );

  const handleShowConsignment = (row) => {
    setConsignmentModalData(row);
    setShowModalConsignment(true);
  };

  const getTableHeadersAccountConsignmentDashboard = (handleShowConsignment) =>
    userData.Type === "Admin"
      ? [
        {
          headerName: "TissueID",
          field: "TissueID",
          filter: true,
        },
        {
          headerName: "Product Code",
          field: "ProductCode",
          filter: true,
        },
        {
          headerName: "Ship Date",
          field: "ShipDate",
          filter: true,
        },
        {
          headerName: "Expiration Date",
          field: "ExpirationDate",
          filter: true,
        },
        {
          headerName: "Days on Consignment",
          field: "DaysOnConsignment",
          filter: true,
          cellRenderer: (params) =>
            params.data.DaysOnConsignment?.props.children,
        },
        {
          headerName: "Action",
          field: "",
          cellRenderer: (params) => (
            <TableOptionsCell
              optionOne="View"
              optionOneType="warning"
              optionOneClickFn={() => handleShowConsignment(params.data)}
              rowData={params.data}
            />
          ),
        },
      ]
      : [
        {
          headerName: "TissueID",
          field: "TissueID",
          filter: true,
        },
        {
          headerName: "Product Code",
          field: "ProductCode",
          filter: true,
        },
        {
          headerName: "Ship Date",
          field: "ShipDate",
          filter: true,
        },
        {
          headerName: "Expiration Date",
          field: "ExpirationDate",
          filter: true,
        },
        {
          headerName: "Days on Consignment",
          field: "DaysOnConsignment",
          filter: true,
        },
      ];

  const tableHeadersAccountConsignmentDashboard =
    getTableHeadersAccountConsignmentDashboard(handleShowConsignment);

  const tableHeadersManufacturerDashboard = [
    {
      headerName: "Manufacturer",
      field: "ManufacturerName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.ManufacturerName}
          path={`/Manufacturer/${params.data.ID}`}
        />
      ),
    },
    {
      headerName: "Accounts",
      field: "AccountsCount",
      filter: true,
    },
    {
      headerName: "Current Sales YTD",
      field: "CurrentSalesYTD",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params.data.CurrentSalesYTD).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.CurrentSalesYTD).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Realized Sales YTD",
      field: "RealizedSalesYTD",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params.data.RealizedSalesYTD).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.RealizedSalesYTD).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Active Accounts YTD",
      field: "ActiveAccountsYTD",
      filter: true,
    },
    {
      headerName: "Current Sales MTD",
      field: "CurrentSalesMTD",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params.data.CurrentSalesMTD).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.CurrentSalesMTD).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Realized Sales MTD",
      field: "RealizedSalesMTD",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params.data.RealizedSalesMTD).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.RealizedSalesMTD).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Active Accounts MTD",
      field: "ActiveAccountsMTD",
      filter: true,
      // cellDataType: "number",
      // valueGetter: (params) =>
      //   parseFloat(String(params.data.ActiveMTD).replace(/[^0-9.-]+/g, "")),
      // cellRenderer: (params) => {
      //   const value = parseFloat(
      //     String(params.data.ActiveMTD).replace(/[^0-9.-]+/g, "")
      //   );
      //   return `$${value.toLocaleString()}`;
      // },
    },
    // {
    //   headerName: "Action",
    //   field: "",
    //   cellRenderer: (params) => (
    //     <TableOptionsCell
    //       optionOne="View"
    //       optionOneType="warning"
    //       optionOneClickPath={`/Manufacturer/${params.data.ID}`}
    //       rowData={params.data}
    //     />
    //   ),
    // },
  ];

  const tableHeadersASUsersDashboard = [
    {
      headerName: "Name",
      field: "Name",
      filter: true,

      cellRenderer: (params) => (
        <TableLink
          value={params.data.Name}
          path={`/User/${params.data.UserID}`}
        />
      ),
    },
    {
      headerName: "Role",
      field: "",
      filter: true,
      cellRenderer: (params) => <StatusIndicator params={params} />,
    },
    {
      headerName: "Region",
      field: "Region",
      filter: true,
      cellRenderer: (params) => params.data.Region?.props.children,
    },
    {
      headerName: "Email",
      field: "Email",
      filter: true,
    },
    {
      headerName: "Phone",
      field: "Phone",
      filter: true,
    },
    // {
    //   headerName: "Action",
    //   field: "",
    //   cellRenderer: (params) => (
    //     <TableOptionsCell
    //       optionOne="View"
    //       optionOneType="warning"
    //       optionOneClickPath={`/ASUserDetails/${params.data.ID}`}
    //       rowData={params.data}
    //     />
    //   ),
    // },
  ];

  const tableHeadersAccountUserDashboard = [
    {
      headerName: "Name",
      field: "FirstName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={[
            params.data.Prefix,
            params.data.FirstName,
            params.data.LastName,
          ]
            .filter(Boolean)
            .join(" ")}
          path={`/User/${params.data.UserID ?? params.data.ID}`}
        />
      ),
    },
    {
      headerName: "Account",
      field: "Account",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.AccountName}
          path={`/Account/${params.data.AccountID}`}
        />
      ),
    },
    {
      headerName: "Email",
      field: "Email",
      filter: true,
    },
    {
      headerName: "Phone",
      field: "Phone",
      filter: true,
    },
    {
      headerName: "User Type",
      field: "AccountContactType",
      filter: true,
    },
    {
      headerName: "Provider NPI",
      field: "ProviderNPI",
      filter: true,
    },
    {
      headerName: "Status",
      field: "",
      // filter: true,
      cellRenderer: (params) => {
        return params.data.Invited == 0 && params.data.InviteAccepted == 0 && params.data.TVUser == 0 ? (
          <>No Access</>
        ) : params.data.Invited == 1 && params.data.InviteAccepted == 0 ? (
          <>Invited</>
        ) : params.data.InviteAccepted == 1 ? (
          <>Active</>
        ) : (
          <>NA</>
        );
      },
    },
    // Lifecycle actions belong only on the unified Users page.
    ...(canInviteUsers || canRevokeUsers
      ? [
          {
            headerName: "Options",
            field: "",
            cellRenderer: (params) => {
              if (
                params.data.Invited === undefined ||
                params.data.InviteAccepted === undefined
              ) {
                return "NA";
              } else {
                if (params.data.InviteAccepted) {
                  return canRevokeUsers ? (
                    <TableOptionsCell
                      optionOne="Revoke Access"
                      optionOneType="failure"
                      optionOneClickFn={() =>
                        openInvokeAccountUserAccessModal(params.data)
                      }
                      rowData={params.data}
                    />
                  ) : null;
                } else if (!params.data.InviteAccepted && params.data.Invited) {
                  return canInviteUsers ? (
                    <TableOptionsCell
                      optionOne="Cancel Invite"
                      optionOneType="failure"
                      optionOneClickFn={() =>
                        openCancelInviteAccountUserModal(params.data)
                      }
                      rowData={params.data}
                    />
                  ) : null;
                } else {
                  if (!canInviteUsers) return null;
                  const inviteDisabled = !hasInvitableEmail(params.data);

                  return (
                    <TableOptionsCell
                      optionOne="Invite"
                      optionOneType="success"
                      optionOneDisabled={inviteDisabled}
                      optionOneTitle={
                        inviteDisabled
                          ? "Add an email address before sending an invite."
                          : undefined
                      }
                      optionOneClickFn={() =>
                        openInviteAccountUserModal(params.data)
                      }
                      rowData={params.data}
                    />
                  );
                }
              }
            },
          },
        ]
      : []),
  ];

  const tableHeadersDistributorUserDashboard = [
    {
      headerName: "Name",
      field: "Name",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.Name}
          path={`/User/${params.data.UserID ?? params.data.ID}`}
        />
      ),
    },
    {
      headerName: "Distributor",
      field: "DistributorName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.DistributorName}
          path={`/Distributor/${params.data.DistributorID}`}
        />
      ),
    },
    {
      headerName: "Email",
      field: "Email",
      filter: true,
    },
    {
      headerName: "Phone",
      field: "Phone",
      filter: true,
    },
    // {
    //   headerName: "Action",
    //   field: "",

    //   cellRenderer: (params) => (
    //     <TableOptionsCell
    //       optionOne="View"
    //       optionOneType="warning"
    //       optionOneClickPath={`/User/${params.data.UserID ?? params.data.ID}`}
    //       rowData={params.data}
    //     />
    //   ),
    // },
  ];

  const tableHeadersInvoices = [
    {
      headerName: "Invoice Number",
      field: "InvoiceNumber",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.InvoiceNumber}
          path={`/InvoiceHome/${params.data.ID}`}
        />
      ),
    },
    {
      headerName: "Status",
      field: "",
      filter: true,
      cellRenderer: (params) => {
        const dashboardStatus = params?.data?.DashboardInvoiceStatus;

        if (dashboardStatus?.text && dashboardStatus?.statusClass) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div className={`status status-${dashboardStatus.statusClass}`}></div>
              <Text variant="smallText" color={dashboardStatus.textColor}>
                {dashboardStatus.text}
              </Text>
            </div>
          );
        }

        return <StatusIndicator params={params} />;
      },
    },
    {
      headerName: "PO Number",
      field: "PONumber",
      filter: true,
      cellRenderer: (params) => {
        const orderType = params.data.OrderType.split(" ").join("");
        return (
          <TableLink
            value={params.data.PONumber}
            path={`/${orderType}/${params.data.OrderID}`}
          />
        );
      },
    },
    {
      headerName: "Invoice Date",
      field: "InvoiceDate",
      filter: true,
      isSearchable: true,
    },
    {
      headerName: "Due Date",
      field: "InvoiceDueDate",
      filter: true,
    },
    {
      headerName: "Account Name",
      field: "AccountName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.AccountName}
          path={`/Account/${params.data.AccountID}`}
        />
      ),
    },
    {
      headerName: "Distributor",
      field: "DistributorName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.DistributorName}
          path={`/Distributor/${params.data.DistributorID}`}
        />
      ),
    },

    userData.Type === "Admin" ||
      userData.Type === "ASD" ||
      userData.Type === "Authorizer" ||
      userData.Type === "Viewer"
      ? {
        headerName: "Manufacturer Name",
        field: "ManufacturerName",
        filter: true,
        cellRenderer: (params) => (
          <TableLink
            value={params.data.ManufacturerName}
            path={`/Manufacturer/${params.data.ManufacturerID}`}
          />
        ),
      }
      : {
        headerName: "Manufacturer Name",
        field: "ManufacturerName",
        filter: true,
      },
    {
      headerName: "Total",
      field: "InvoiceTotal",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params.data.InvoiceTotal).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.InvoiceTotal).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    // {
    //   headerName: "Action",
    //   field: "",
    //   cellRenderer: (params) => (
    //     <TableOptionsCell
    //       optionOne="View"
    //       optionOneType="warning"
    //       optionOneClickPath={`/InvoiceHome/${params.data.ID}`}
    //       rowData={params.data}
    //     />
    //   ),
    // },
  ];

  const tableHeadersDistributorSalesRep = [
    {
      headerName: "Name",
      field: "FirstName",
      cellRenderer: (params) => (
        <TableLink
          value={params.data.FirstName + " " + params.data.LastName}
          path={`/User/${params.data.UserID ?? params.data.ID}`}
        />
      ),
    },
    {
      headerName: "Phone",
      field: "Phone",
    },
    {
      headerName: "Email",
      field: "Email",
    },
    {
      headerName: "Role",
      field: "Role",
    },
  ];

  const tableHeadersAccountHomeInvoiceTable = [
    {
      headerName: "Invoice",
      field: "InvoiceNumber",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.InvoiceNumber}
          path={`/InvoiceHome/${params.data.ID}`}
        />
      ),
    },
    {
      headerName: "Invoice Date",
      field: "InvoiceDate",
      filter: true,
    },
    {
      headerName: "Due Date",
      field: "InvoiceDueDate",
      filter: true,
    },
    {
      headerName: "Due In",
      field: "DueIn",
      filter: true,
    },
    // {
    //   headerName: "Account Name",
    //   field: "AccountName",
    //   filter: true,
    //   cellRenderer: (params) => (
    //     <TableLink
    //       value={params.data.AccountName}
    //       path={`/Account/${params.data.AccountID}`}
    //     />
    //   ),
    // },
    userData.Type === "Admin" ||
      userData.Type === "ASD" ||
      userData.Type === "Authorizer" ||
      userData.Type === "Viewer"
      ? {
        headerName: "Manufacturer",
        field: "ManufacturerName",
        filter: true,
        cellRenderer: (params) => (
          <TableLink
            value={params.data.ManufacturerName}
            path={`/Manufacturer/${params.data.ManufacturerID}`}
          />
        ),
      }
      : {
        headerName: "Manufacturer",
        field: "ManufacturerName",
        filter: true,
      },
    {
      headerName: "Total",
      field: "InvoiceTotal",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params.data.InvoiceTotal).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.InvoiceTotal).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Open Balance",
      field: "OpenBalance",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params.data.OpenBalance).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.OpenBalance).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    // {
    //   headerName: "Action",
    //   field: "",
    //   sortable: false,
    //   cellRenderer: (params) => (
    //     <TableOptionsCell
    //       optionOne="View"
    //       optionOneType="warning"
    //       optionOneClickPath={`/InvoiceHome/${params.data.ID}`}
    //       rowData={params.data}
    //     />
    //   ),
    // },
  ];

  const tableHeadersAccountHomeRecentOrders = [
    {
      headerName: "PO Number",
      field: "PONumber",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.PONumber}
          path={getOrderDetailPath(params.data)}
        />
      ),
    },
    {
      headerName: "Order Date",
      field: "OrderDate",
      filter: true,
    },
    {
      headerName: "Order Total",
      field: "OrderTotal",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params.data.OrderTotal).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.OrderTotal).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Status",
      field: "Status",
      filter: true,
      cellRenderer: (params) => (
        <StatusIndicatorHeader
          statusType={
            ACCOUNT_HOME_ORDER_STATUS_TYPES[params.data.Status] ?? "default"
          }
          status={params.data.Status}
        />
      ),
    },
    {
      headerName: "Action",
      field: "",
      sortable: false,
      cellRenderer: (params) => (
        <TableOptionsCell
          optionOne="View"
          optionOneType="warning"
          optionOneClickPath={getOrderDetailPath(params.data)}
          rowData={params.data}
        />
      ),
    },
  ];

  const tableHeadersAccountUsers = [
    {
      headerName: "Name",
      field: "FirstName",
      filter: true,
      cellRenderer: (params) => {
        return params.data.RoleType === "Contact" ? (
          <TableLink
            value={params.data.FirstName + " " + params.data.LastName}
            path={`/User/${params.data.UserID ?? params.data.ID}`}
            state={"Contact"}
          />
        ) : (
          <TableLink
            value={params.data.FirstName + " " + params.data.LastName}
            path={`/User/${params.data.UserID ?? params.data.ID}`}
          />
        );
      },
    },
    {
      headerName: "Account Role",
      field: "AccountContactType",
      filter: true,
      valueGetter: (params) => getAccountRoleLabel(params.data),
    },
    {
      headerName: "Email",
      field: "Email",
      filter: true,
    },
    {
      headerName: "Phone",
      field: "Phone",
      filter: true,
    },
    {
      headerName: "Provider NPI",
      field: "ProviderNPI",
      filter: true,
    },
    {
      headerName: "Status",
      field: "",
      // filter: true,
      cellRenderer: (params) => {
        return params.data.Invited == 0 && params.data.InviteAccepted == 0 && params.data.TVUser == 0 ? (
          <>No Access</>
        ) : params.data.Invited == 1 && params.data.InviteAccepted == 0 ? (
          <>Invited</>
        ) : params.data.InviteAccepted == 1 ? (
          <>Active</>
        ) : (
          <>NA</>
        );
      },
    },
  ];
  const tableHeadersManufacturerUsers = [
    {
      headerName: "Name",
      field: "FirstName",
      filter: true,
      cellRenderer: (params) => {
        return (
          <TableLink
            value={params.data.FirstName + " " + params.data.LastName}
            path={`/User/${params.data.UserID ?? params.data.ID}`}
          />
        );
      },
    },
    {
      headerName: "Manufacturer",
      field: "ManufacturerName",
      filter: true,
    },
    {
      headerName: "Email",
      field: "Email",
      filter: true,
    },
    {
      headerName: "Phone",
      field: "Phone",
      filter: true,
    },
  ];

  const tableHeadersChildAccounts = [
    {
      headerName: "Account Name",
      field: "AccountName",
      filter: true,
      cellRenderer: (params) => (
        <TableLink
          value={params.data.AccountName}
          path={`/Account/${params.data.ID}`}
        />
      ),
    },
    userData.Type === "Admin" ||
      userData.Type === "ASD" ||
      userData.Type === "Authorizer" ||
      userData.Type === "Viewer"
      ? {
        headerName: "Distributor Name",
        field: "DistributorName",
        filter: true,
        cellRenderer: (params) => (
          <TableLink
            value={params.data.DistributorName}
            path={`/Distributor/${params.data.DistributorID}`}
          />
        ),
      }
      : {
        headerName: "Distributor Name",
        field: "DistributorName",
        filter: true,
      },
    {
      headerName: "Region Name",
      field: "RegionName",
      filter: true,
    },
    // {
    //   headerName: "Action",
    //   field: "",
    //   cellRenderer: (params) => (
    //     <TableOptionsCell
    //       optionOne="View"
    //       optionOneType="warning"
    //       optionOneClickPath={`/Account/${params.data.ID}`}
    //     />
    //   ),
    // },
  ];

  const getTableHeadersManufacturerAccountDashboard = (
    handleDeleteAccountManufacturerClick
  ) =>
    userData.Type === "Admin" && hasPermission(userData, "manage_manufacturers.edit")
      ? [
        {
          headerName: "Account Name",
          field: "AccountName",
          filter: true,
          cellRenderer: (params) => (
            <TableLink
              value={params.data.AccountName}
              path={`/Account/${params.data.ID}`}
            />
          ),
        },
        {
          headerName: "Status",
          field: "Status",
          filter: true,
          cellRenderer: (params) => {
            if (params.data.IsApproved === undefined) {
              return "";
            } else {
              return params.data.IsApproved ? "Approved" : "Pending";
            }
          },
        },
        {
          headerName: "Action",
          field: "",
          cellRenderer: (params) => (
            <TableOptionsCell
              optionOne="Remove"
              optionOneType="failure"
              optionOneClickFn={() =>
                handleDeleteAccountManufacturerClick(params.data)
              }
              rowData={params.data}
            />
          ),
        },
      ]
      : [
        {
          headerName: "Account Name",
          field: "AccountName",
          filter: true,
          cellRenderer: (params) => (
            <TableLink
              value={params.data.AccountName}
              path={`/Account/${params.data.ID}`}
            />
          ),
        },
        {
          headerName: "Status",
          field: "Status",
          filter: true,
          cellRenderer: (params) => {
            return params.data.IsApproved ? "Approved" : "Pending";
          },
        },
      ];

  const tableHeadersManufacturerAccountDashboard =
    getTableHeadersManufacturerAccountDashboard(
      handleDeleteAccountManufacturerClick
    );

  const renderedColumnDefs = useMemo(() => {
    if (DistributorDataScreen) {
      return tableHeadersDistributorSalesRep;
    } else if (DistributorAccountScreen) {
      return tableHeadersDistributorAccount;
    } else if (AccountHomeInvoiceScreen) {
      return tableHeadersAccountHomeInvoiceTable;
    } else if (AccountHomeRecentOrdersScreen) {
      return tableHeadersAccountHomeRecentOrders;
    } else if (AccountManufacturerScreen) {
      return tableHeadersAccountManufacturer;
    } else if (AccountUsersScreen) {
      return tableHeadersAccountUsers;
    } else if (ManufacturerUsersScreen) {
      return tableHeadersManufacturerUsers;
    } else if (ChildAccountsScreen) {
      return tableHeadersChildAccounts;
    } else if (ApprovalsDashboardScreen) {
      return tableHeadersApprovalsDashboard;
    } else if (InvoiceDashboardNewScreen) {
      return tableHeadersInvoices;
    } else if (AccountProductLogScreen) {
      return tableHeadersAccountProductLogScreen;
    } else if (AccountConsignmentDashboardScreen) {
      return tableHeadersAccountConsignmentDashboard;
    } else if (ManufacturerDashboardScreen) {
      return tableHeadersManufacturerDashboard;
    } else if (ASUsersDashboardScreen) {
      return tableHeadersASUsersDashboard;
    } else if (AccountUserDashboardScreen) {
      return tableHeadersAccountUserDashboard;
    } else if (DistributorUserDashboardScreen) {
      return tableHeadersDistributorUserDashboard;
    } else if (ManufacturerAccountDashboardScreen) {
      return tableHeadersManufacturerAccountDashboard;
    }
    // else if (ManufacturerProductScreen) {
    //   return tableHeadersManufacturerProduct;
    // }
    else {
      return null;
    }
  }, [screen, approvalTabType, userData, isReady, readOnly, additionalData]);

  const isPhone = !useScreen("sm");

  const handleFile = async ({ file, onSuccess }) => {
    if (file.size > 4194304) {
      message.error("File size should be less than 4MB");
      setNewDpaFileName(null);
      setNewDpaFile(null);
      setUploadFileList([]);
      return;
    }
    if (file.type !== "application/pdf" && !/\.pdf$/i.test(file.name || "")) {
      message.error("DPA must be a PDF file");
      setNewDpaFileName(null);
      setNewDpaFile(null);
      setUploadFileList([]);
      return;
    }
    setUploadFileList([{ name: file.name, status: "done", uid: "1" }]);
    setNewDpaFile(file);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    // action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    accept: [".pdf"],
    // disabled: !isEditable,
    fileList: uploadFileList,
    customRequest: handleFile,
    // onPreview: downloadFile,
    onRemove: (file) => {
      setNewDpaFile(null);
      setUploadFileList([]);
      setNewDpaFileName(null);
    },
    onChange(info) {
      console.log("File Info: ", info);
      const { status } = info.file;
      // console.log("Status: ", status);
      if (status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (status === "done") {
        // setIvrReport(info.file.originFileObj);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const [inviteAccountUserModalVisible, setInviteAccountUserModalVisible] = useState(false);

  const [inviteAccountUserModalData, setInviteAccountUserModalData] = React.useState({});

  const openInviteAccountUserModal = (record) => {
    if (
      !AccountUserDashboardScreen ||
      !canInviteUsers ||
      !hasInvitableEmail(record)
    ) {
      return;
    }

    console.log("Invite Account User Modal Opened: ", record);
    setInviteAccountUserModalData(record);
    setInviteAccountUserModalVisible(true);
  };

  const handleCancelInviteAccountUser = () => {
    setInviteAccountUserModalVisible(false);
  }

  const handleOkInviteAccountUser = async () => {
    if (!AccountUserDashboardScreen || !canInviteUsers) {
      setInviteAccountUserModalVisible(false);
      return;
    }
    console.log("Invite Account User Data: ", inviteAccountUserModalVisible);
    setInviteAccountUserModalVisible(false);
    setShowLoader(true);
    // approve manufacturer
    const apiServe = new APIService();
    const postObj = {
      AccountID: inviteAccountUserModalData.AccountID,
      UserID: inviteAccountUserModalData.UserID,
      ID: inviteAccountUserModalData.ID,
      Email: inviteAccountUserModalData.Email,
    };
    const response = await apiServe.updateDataToBackend(
      postObj,
      "inviteaccountuser"
    );
    console.log("Invite Account User Response: ", response);
    setShowLoader(false);
    if (response?.status === 200) {
      Swal.fire("Invited!", "User Invited Successfully.", "success").then(
        () => {
          window.location.reload();
        }
      );
    }
    else {
      Swal.fire("Error!", "Failed to invite user.", "error");
    }
  };

  const [invokeAccountUserAccessModalVisible, setInvokeAccountUserAccessModalVisible] = useState(false);

  const openInvokeAccountUserAccessModal = (record) => {
    if (!AccountUserDashboardScreen || !canRevokeUsers) return;
    console.log("Invoke Account User Access Modal Opened: ", record);
    setInviteAccountUserModalData(record);
    setInvokeAccountUserAccessModalVisible(true);
  }

  const handleCancelInvokeAccountUserAccess = () => {
    setInvokeAccountUserAccessModalVisible(false);
  }

  const handleOkInvokeAccountUserAccess = async () => {
    if (!AccountUserDashboardScreen || !canRevokeUsers) {
      setInvokeAccountUserAccessModalVisible(false);
      return;
    }
    setInvokeAccountUserAccessModalVisible(false);
    setShowLoader(true);
    // approve manufacturer
    const apiServe = new APIService();
    const postObj = {
      AccountID: inviteAccountUserModalData.AccountID,
      UserID: inviteAccountUserModalData.UserID,
      ID: inviteAccountUserModalData.ID,
      Email: inviteAccountUserModalData.Email,
    };
    const response = await apiServe.updateDataToBackend(
      postObj,
      "revokeaccountuseraccess"
    );
    console.log("Revoke Account User Access Response: ", response);
    setShowLoader(false);
    if (response?.status === 200) {
      Swal.fire("Revoked!", "User Access Revoked Successfully.", "success").then(
        () => { 
          window.location.reload();
        }
      );
    }
    else {
      Swal.fire("Error!", "Failed to revoke user access.", "error");
    }
  };

  const [cancelInviteAccountUserModalVisible, setCancelInviteAccountUserModalVisible] = useState(false);

  const openCancelInviteAccountUserModal = (record) => {
    if (!AccountUserDashboardScreen || !canInviteUsers) return;
    console.log("Cancel Invite Account User Modal Opened: ", record);
    setInviteAccountUserModalData(record);
    setCancelInviteAccountUserModalVisible(true);
  }

  const handleCancelCancelInviteAccountUser = () => {
    setCancelInviteAccountUserModalVisible(false);
  }

  const handleOkCancelInviteAccountUser = async () => {
    if (!AccountUserDashboardScreen || !canInviteUsers) {
      setCancelInviteAccountUserModalVisible(false);
      return;
    }
    setCancelInviteAccountUserModalVisible(false);
    setShowLoader(true);
    // approve manufacturer
    const apiServe = new APIService();
    const postObj = {
      AccountID: inviteAccountUserModalData.AccountID,
      UserID: inviteAccountUserModalData.UserID,
      ID: inviteAccountUserModalData.ID,
      Email: inviteAccountUserModalData.Email,
    };
    const response = await apiServe.updateDataToBackend(
      postObj,
      "cancelinviteaccountuser"
    );
    console.log("Cancel Invite Account User Response: ", response);
    setShowLoader(false);
    if (response?.status === 200) {
      Swal.fire("Cancelled!", "User Invite Cancelled Successfully.", "success").then(
        () => {
          window.location.reload();
        }
      );
    }
    else {
      Swal.fire("Error!", "Failed to cancel user invite.", "error");
    }
  };
  
  return (
    <div>
      {showLoader && (
        <Spin
          fullscreen
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
        />
      )}
      {!hideInternalSearch &&
        (screen === "AccountDashboard" ||
        screen === "ApprovalsDashboard" ||
        screen === "OrdersDashboard" ||
        screen === "InvoiceDashboard" ||
        screen === "IVRSubmissions" ||
        screen === "AccountProductLog" ||
        screen === "DistributorDashboard" ||
        screen === "AccountConsignmentDashboard") && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Input.Search
                placeholder="Search"
                // suffix={<SearchOutlined />}
                style={{ height: "36px" }}
                onSearch={(value) => setSearchKeyword(value)}
              />
            </div>
          </div>
        )}
      {DistributorDataScreen ||
        DistributorAccountScreen ||
        AccountHomeInvoiceScreen ||
        AccountHomeRecentOrdersScreen ||
        AccountManufacturerScreen ||
        AccountUsersScreen ||
        ManufacturerUsersScreen ||
        ChildAccountsScreen ||
        ApprovalsDashboardScreen ||
        InvoiceDashboardNewScreen ||
        // AccountProductLogScreen ||
        AccountConsignmentDashboardScreen ||
        ManufacturerDashboardScreen ||
        ASUsersDashboardScreen ||
        AccountUserDashboardScreen ||
        DistributorUserDashboardScreen ||
        ManufacturerAccountDashboardScreen ||
        ManufacturerProductScreen ? (
        <>
          <CommonTable
            rowData={data}
            columnDefs={renderedColumnDefs}
            searchKeyword={searchKeyword}
            pagination={!InvoiceDashboardNewScreen}
            screen={screen}
            loading={loading}
          />
        </>
      ) : (
        <Table
          onChange={tableOnChange}
          dataSource={data}
          columns={columns}
          components={components}
          pagination={
            shouldPaginate ? { pageSize: 10, total: totalCount } : false
          }
        />
      )}



      {showApproveModal && (
        <div>
          <Modal
            title="Are you sure you want to approve this order?"
            open={showApproveModal}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            centered={true}
            footer={false}
          >
            <p>
              This action will send the order to the manufacturer for
              processing.
            </p>
            <Button
              type="primary"
              onClick={handleOk}
              style={{ background: "#27a907" }}
            >
              Approve
            </Button>
          </Modal>
        </div>
      )}
      {showInvoiceModal && isPrepaidApprovalsTab && (
        <InvoiceFormNew
          orderType={orderData?.OrderType}
          orderData={orderData}
          showInvoiceModal={showInvoiceModal}
          onClose={() => setShowInvoiceModal(false)}
        />
      )}
      {showInvoiceModal && !isPrepaidApprovalsTab && (
        <div>
          <Modal
            title="Add Details"
            width={900}
            open={showInvoiceModal}
            onCancel={() => setShowInvoiceModal(false)}
            footer={[]}
          >
            <InvoiceForm
              orderType={orderData.OrderType}
              orderData={orderData}
            />
          </Modal>
        </div>
      )}
      {showViewProductModal && (
        <div>
          <Modal
            title="View Product"
            open={showViewProductModal}
            onCancel={() => setShowViewProductModal(false)}
            centered={true}
            footer={null}
          >
            <Formik
              initialValues={initialProductValues}
              onSubmit={handleProductSubmit}
              enableReinitialize
            >
              {({ values, handleChange, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Row gutter={16} className="form-row">
                    <Col span={24}>
                      <label htmlFor="ManufacturerName" className="form-label">
                        Manufacturer Name
                      </label>
                      <Input
                        id="ManufacturerName"
                        name="ManufacturerName"
                        value={values.ManufacturerName}
                        // onChange={handleChange}
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row gutter={16} className="form-row">
                    <Col span={12}>
                      <label htmlFor="ProductCode" className="form-label">
                        Product Code
                      </label>
                      <Input
                        id="ProductCode"
                        name="ProductCode"
                        value={values.ProductCode}
                        onChange={handleChange}
                      />
                    </Col>
                    <Col span={12}>
                      <label htmlFor="StandardPrice" className="form-label">
                        Product Standard Cost
                      </label>
                      <Input
                        id="StandardPrice"
                        name="StandardPrice"
                        value={values.StandardPrice}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  <Row gutter={16} className="form-row">
                    <Col span={24}>
                      <label htmlFor="ProductName" className="form-label">
                        Product Name
                      </label>
                      <Input
                        id="ProductName"
                        name="ProductName"
                        value={values.ProductName}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  {userData.Type === "Admin" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        type="primary"
                        onClick={() => handleSubmit()}
                        style={{ background: "#27a907", marginTop: "20px" }}
                      >
                        Okay
                      </Button>
                      <Button
                        type="primary"
                        onClick={() =>
                          handleProductDelete(initialProductValues)
                        }
                        style={{
                          background: "#e3e3e3",
                          color: "#616161",
                          marginTop: "20px",
                        }}
                      >
                        Delete Product
                      </Button>
                    </div>
                  )}
                </form>
              )}
            </Formik>
          </Modal>
        </div>
      )}
      <Modal
        title="Product on Consignment"
        open={showModalConsignment}
        onCancel={handleCancelConsignment}
        centered={true}
        footer={false}
      >
        <div>
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Account Name">
                  <Input
                    defaultValue={consignmentModalData?.AccountName}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Tissue ID">
                  <Input
                    defaultValue={consignmentModalData?.TissueID}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Product Code">
                  <Input
                    defaultValue={consignmentModalData?.ProductCode}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Date Ordered">
                  <Input
                    defaultValue={consignmentModalData?.OrderDate}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Expiration Date">
                  <Input defaultValue={"Expiration Date"} disabled />
                </Form.Item>
              </Col>
            </Row>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                type="primary"
                onClick={handleCancelConsignment}
                style={{ background: "#27a907" }}
              >
                Okay
              </Button>
              {userData.Type === "Admin" && userData.IsSuperAdmin && (
                <Button
                  type="primary"
                  style={{ background: "#ff0000" }}
                  onClick={handleDeleteConsignmentProduct}
                >
                  Delete Product
                </Button>
              )}
            </div>
          </Form>
        </div>
      </Modal>
      {showAssignAccountModal && assignAccountData && (
        <Modal
          title="Assign Account"
          width={600}
          open={showAssignAccountModal}
          onCancel={() => setShowAssignAccountModal(false)}
          footer={[]}
        >
          <AssignAccountToDistUser assignAccountData={assignAccountData} />
        </Modal>
      )}
      {changeAssignmentModal && changeAssignmentData && (
        <Modal
          title="Change Assignment"
          width={600}
          open={changeAssignmentModal}
          onCancel={() => setChangeAssignmentModal(false)}
          footer={[]}
        >
          <ChangeAssignmentDistUser assignAccountData={changeAssignmentData} />
        </Modal>
      )}
      {attachDpaRow && Number(attachDpaRow.AccountID) === Number(additionalData?.ID) && !readOnly && (
        <AttachDpaModal key={`${attachDpaRow.AccountID}:${attachDpaRow.ID}`} row={attachDpaRow}
          account={additionalData} user={user} isReady={isReady} readOnly={readOnly}
          onClose={() => setAttachDpaRow(null)} onRefresh={props.onManufacturersRefresh} />
      )}
      {showManufacturerApproveModal && !readOnly && (
        <div>
          <ModalView
            modalTitle={`Approve ${manApproveModalData?.ManufacturerName} for ${additionalData?.AccountName}`}
            isOpen={showManufacturerApproveModal}
            onClose={handleCancelApproveManufacturer}
            isLoading={approvalPricingLoading || approvalSubmitting}
            minWidth="800px"
            maxWidth="900px"
            parentClassname="approve-manufacturer-pricing-modal"
            textInputComponent={
              <div className="approval-pricing-content">
                <div className="approval-pricing-primary-fields">
                  <div className="approval-dpa-field">
                    <span className="text-input-title">
                      <Text variant="tinyText">Upload DPA</Text>
                      <RequiredIcon />
                    </span>
                    <Upload {...uploadProps}>
                      <Button icon={<UploadOutlined />} rootClassName="upload-button-container">
                        Upload
                      </Button>
                    </Upload>
                  </div>
                  <TextInput
                    titleText="Default Account Discount"
                    placeholder="0"
                    value={accountDiscountValue}
                    type="number"
                    minValue={0}
                    maxValue={100}
                    step="0.01"
                    inputMode="decimal"
                    isRequired
                    parentClassName="approval-default-discount-field"
                    errorText={
                      isValidDiscount(accountDiscountValue)
                        ? ""
                        : "Enter a discount from 0 to 100 with at most two decimals."
                    }
                    helperText="This discount will be applied to any new product groups added to this manufacturer, for this account only."
                    setValue={handleDefaultDiscountChange}
                  />
                  <DropdownComponent
                    label="Default Pricing Strategy"
                    placeholder="Select pricing strategy"
                    options={pricingStrategyOptions}
                    value={approvalDefaultStrategy}
                    onChange={handleApprovalDefaultStrategy}
                    isRequired
                    parentClassname="approval-pricing-strategy-field"
                  />
                </div>

                <div className="approval-pricing-heading">
                  <Text variant="h2">Pricing Strategy</Text>
                  <Text variant="tinyText" color="lightText">
                    Set a pricing strategy and applicable discount for each product group in this manufacturer. These prices apply to this account only.
                  </Text>
                  <Text variant="tinyText" color="lightText">
                    Settings can also be changed later from the account product-group editor.
                  </Text>
                </div>

                <div className="approval-product-groups">
                  {approvalProductGroups.map((group) => (
                    <div className="approval-product-group-row" key={group.ID}>
                      <div className="approval-product-group-title">
                        <Text variant="h2">{group.ProductGroupName}</Text>
                        <Text variant="tinyText" color="lightText">
                          {group.QCode || "No HCPCS Code"}
                        </Text>
                      </div>
                      <div className="approval-product-group-controls">
                        <div className="approval-discount-switch">
                          <Text variant="tinyText">Apply Discount</Text>
                          <Switch
                            checked={!group.CustomPricing}
                            checkedChildren="✓"
                            unCheckedChildren="×"
                            aria-label={`Apply discount to ${group.ProductGroupName}`}
                            onChange={(checked) => handleApprovalGroupMode(group.ID, checked)}
                          />
                        </div>
                        <TextInput
                          titleText="Product Group Discount"
                          placeholder="0"
                          value={group.CustomPricing ? 0 : group.DiscountPercentage}
                          type="number"
                          minValue={0}
                          maxValue={100}
                          step="0.01"
                          inputMode="decimal"
                          isRequired
                          isDisabled={group.CustomPricing}
                          parentClassName="approval-group-discount-field"
                          errorText={
                            !group.CustomPricing && !isValidDiscount(group.DiscountPercentage)
                              ? "Enter 0–100."
                              : ""
                          }
                          setValue={(value) => handleApprovalGroupDiscount(group.ID, value)}
                        />
                      </div>
                    </div>
                  ))}
                  {approvalPricingLoaded && approvalProductGroups.length === 0 && (
                    <Text variant="smallText" color="lightText">
                      No active product groups are configured for this manufacturer.
                    </Text>
                  )}
                </div>

                {approvalError && (
                  <Text variant="smallText" color="failureColor">{approvalError}</Text>
                )}
              </div>
            }
            footerButtonWrapper={
              <div className="footer-button-wrapper-flex-end">
                <CommonButton
                  variant="table"
                  style={{ minWidth: "100px" }}
                  subVariant="success"
                  onClick={handleOkApproveManufacturer}
                  disabled={!approvalFormValid || approvalPricingLoading || approvalSubmitting}
                >
                  {approvalSubmitting ? "Approving…" : "Approve"}
                </CommonButton>
              </div>
            }
          />
        </div>
      )}
      {showManufacturerRemoveModal && (
        <div>
          <Modal
            title="Are you sure you want to remove this manufacturer?"
            open={showManufacturerRemoveModal}
            onOk={handleOkRemoveManufacturer}
            onCancel={handleCancelRemoveManufacturer}
            centered={true}
            footer={false}
          >
            <p>This action will remove the manufacturer from this account.</p>
            <Button
              type="primary"
              onClick={handleOkRemoveManufacturer}
              style={{ background: "#ff0000" }}
            >
              Remove
            </Button>
          </Modal>
        </div>
      )}
      {showAccountManufacturerRemoveModal && !readOnly && (
        <div>
          <Modal
            title="Are you sure you want to remove this account?"
            open={showAccountManufacturerRemoveModal}
            onOk={handleOkRemoveAccountManufacturer}
            onCancel={handleCancelRemoveAccountManufacturer}
            centered={true}
            footer={false}
          >
            <p>This action will remove the account from this manufacturer.</p>
            <Button
              type="primary"
              onClick={handleOkRemoveAccountManufacturer}
              style={{ background: "#ff0000" }}
            >
              Remove
            </Button>
          </Modal>
        </div>
      )}
      {openInvoiceHomeOrderProductsEdit && (
        <Modal
          title="Edit Order Products"
          open={openInvoiceHomeOrderProductsEdit}
          onCancel={() => setOpenInvoiceHomeOrderProductsEdit(false)}
          footer={[]}
        >
          <InvoiceHomeOrderProductsEdit
            data={invoiceHomeOrderProductsEditData}
          />
        </Modal>
      )}

      {AccountUserDashboardScreen && inviteAccountUserModalVisible && (
        <div>
          <Modal
            title="Are you sure you want to invite this user?"
            open={inviteAccountUserModalVisible}
            onOk={handleOkInviteAccountUser}
            onCancel={handleCancelInviteAccountUser}
            centered={true}
            footer={false}
          >
            <p>This action will invite the user to this account.</p>
            <Button
              type="primary"
              onClick={handleOkInviteAccountUser}
              // style={{ background: "#ff0000" }}
              style={{ background: "#27a907" }}
            >
              Invite
            </Button>
          </Modal>
        </div>
      )}

      {AccountUserDashboardScreen && invokeAccountUserAccessModalVisible && (
        <div>
          <Modal
            title="Are you sure you want to revoke access for this user?"
            open={invokeAccountUserAccessModalVisible}
            onOk={handleOkInvokeAccountUserAccess}
            onCancel={handleCancelInvokeAccountUserAccess}
            centered={true}
            footer={false}
          >
            <p>This action will revoke the user's access to this account.</p>
            <Button
              type="primary"
              onClick={handleOkInvokeAccountUserAccess}
              style={{ background: "#ff0000" }}
            >
              Revoke Access
            </Button>
          </Modal>
        </div>
      )}

      {AccountUserDashboardScreen && cancelInviteAccountUserModalVisible && (
        <div>
          <Modal
            title="Are you sure you want to cancel the invite for this user?"
            open={cancelInviteAccountUserModalVisible}
            onOk={handleOkCancelInviteAccountUser}
            onCancel={handleCancelCancelInviteAccountUser}
            centered={true}
            footer={false}
          >
            <p>This action will cancel the invite for this user.</p>
            <Button
              type="primary"
              onClick={handleOkCancelInviteAccountUser}
              style={{ background: "#ff0000" }}
            >
              Cancel Invite
            </Button>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default GenericDashboard;
